import React from 'react'
import update from 'immutability-helper'
import moment from 'moment'
import Modal from 'react-modal'
import { browserHistory } from 'react-router'

import DropzoneComponent from 'react-dropzone-component';
import NavLink from '../Routes/NavLink'
import FeesSelect from '../../helpers/Fees/FeesSelect';
import TenantsSelect from '../Tenants/TenantsSelect.jsx';
import LeasePaymentHistory from '../Billing/LeasePaymentHistory'

import { lease } from '../../core/controllers/Lease.js';
import { leases } from '../../core/controllers/Leases';
import { dropZone } from '../../core/utilities/DropZoneHandler';
import { property } from '../../core/controllers/Property'
import { modal } from '../../core/utilities/modal'
import { documents } from '../../core/controllers/Documents';
import { modalStyles } from '../../core/controllers/ModalStyles';
import PropertiesSelect from '../Properties/PropertiesSelect.jsx';
import SalesReportedList from '../Leases/SalesReportedList'
import LeaseInvoices from '../Leases/LeaseInvoices'

import ActionCenterCard from '../../helpers/Cards/ActionCenter'
import { ActionCenterEntry } from '../../helpers/Cards/ActionCenter'
import { TabGroup } from '../../helpers/Tabs/TabGroup'
import { Tab } from '../../helpers/Tabs/Tab'

// #  TODO move this to seperate component
const Attachment = ({attachment, deleteFunc}) => {
    return (
        <attachment key={attachment.id}>
            <div class={attachment.content_type == 'pdf' ? "col-lg-12 col-md-12 col-sm-12 col-xs-12 col-xs-12" : "col-lg-3 col-md-3 col-sm-4 col-xs-6 col-xs-6"}>
                <span class="deleteDocument" onClick={deleteFunc.bind(this, attachment)}><i class="pe-7s-close"></i></span>
                <a href={attachment.url} target="_blank">
                    { attachment.content_type == 'pdf' ? (
                        <object width="100%" height="500" data={attachment.url} type="application/pdf"></object>
                    ) : (
                        <img src={attachment.url} width="100px" height="100px" />
                    )}
                </a>
            </div>
        </attachment>
    );
};

export default class LeaseEditNew extends React.Component {
    constructor(props) {
        super(props);
        var self = this;

        this.state = {
            leaseID : props.leaseID,
            attachments: null,
            agreement: null,
            sortID: null,
            leaseData: {
                contract_amount: 0,
                payment_recurrence_method: 'month',
                contract_expiration_date: 'Not Active',
                term_length: 1,
                title: '',
                address: '',
                city: '',
                state: '',
                zipcode: '',
                sqft: 0,
                rent_payment_option: null,
                tenant_pay_rent_id: null,
                rent_due_day: 1,
                prorate_amount: 0,
                sales_percentage: 0,
                sales_min: 0,
                sales_max: 0,
                increase_rent_amount: 0,
                increase_rent_length: 1,
                deposit_amount: 0,
                pet_deposit_amount: 0,
                prepaid_end_date: moment().format("Y-MM-DD")
            },
            lease: {
                building_id: 0,
                space_id: 0,
                contract_bathroom_type: '0',
                contract_bedroom_type: '0',
                building_group_id: '0',
                property_id: 0,
                fee_id: 0
            },
            feeDetails: null,
            tenantArray: [],
            selectedProperty: null,
            selectedUnitId: 0,
            notifyTenant: false,
            selected_rent_payment_option: null,
            selected_tenant_pay_rent_id: null,

            showMoveInModal: false,
            tenantsMoveInData: {
                tenant_id: 0,
                securityDeposit: 0,
                petDeposit: 0,
                rentAmount: 0,
                effectiveDate: moment().format("Y-MM-DD"),
                expirationDate: '',
                termLength: 0,
                rentDueDay: 0,
                requestElectronic: false,
                tenantsList: [],
                tenantsIdList: [],
                leaseID: props.leaseId,
                totalSelectedTenants: 0,
                rentPaymentOption: null,
                tenantPayRentId: null,
                collectSecurityDeposit: 'Yes',
                collectPetDeposit: 'Yes',
                collectRentNow: 'Yes',
                startDate: moment().format("Y-MM-DD"),
                endDate: moment().format("Y-MM-DD")
            },

            showMoveOutModal: false,
            tenantsMoveOutData: {
                leaseId: props.leaseID,
                tenantsList: [],
                tenantsIdList: [],
            },
            signature: null,
            completed_signature: null,
            didAddTenant: false,
            showProRate: false,
            showChargeSalePercentage: false,
            showIncreaseRent: false,
            showCollectDeposit: false,
            showCollectPetDeposit: false,
            showPrepaidOption: false,
            invoicingActive: false
        };
        this.lastTenantId = 0;
        this.didSetup = false;
    }

    componentDidMount() {
        var self = this;
        if(!this.props.newLease){
            lease.setLeaseID(this.state.leaseID);
            lease.getLease(function(response) {

                var selectedProperty = null;
                var selectedUnitId = 0;
                var lease = response.data[0].belongTo;
                if (response.data[0].property) {
                    selectedProperty = {
                        details: response.data[0].property,
                        units: response.data[0].properties_units,
                        photo: response.data[0].property_photo
                    }
                    if (response.data[0].assigned_property_unit) {
                        selectedUnitId = response.data[0].assigned_property_unit.property_unit_id;
                    }
                    lease.property_id = selectedProperty.details.property_id;
                }

                var leaseData = response.data[0].data;
                leaseData.contract_amount = leaseData.contract_amount / 100
                leaseData.contract_amount = new Intl.NumberFormat('en', { maximumSignificantDigits: 10 }).format(leaseData.contract_amount);
                leaseData.rent_payment_option = lease.rent_payment_type;
                if (leaseData.rent_payment_option == 'single') {
                    var tenants = response.data[0].tenants;
                    tenants.forEach(tenant => {
                        if (tenant.tenant.pays_rent == 1) {
                            leaseData.tenant_pay_rent_id = tenant.tenant.tenant_id;
                        }
                    });
                }
                var showCollectDeposit = false;
                leaseData.security_deposit = leaseData.security_deposit / 100
                leaseData.security_deposit = new Intl.NumberFormat('en', { maximumSignificantDigits: 10 }).format(leaseData.security_deposit);
                if (leaseData.security_deposit != null && parseFloat(leaseData.security_deposit) > 0) {
                    showCollectDeposit = true;
                }
                var showCollectPetDeposit = false;
                leaseData.pet_deposit = leaseData.pet_deposit / 100
                leaseData.pet_deposit = new Intl.NumberFormat('en', { maximumSignificantDigits: 10 }).format(leaseData.pet_deposit);
                if (leaseData.pet_deposit != null && parseFloat(leaseData.pet_deposit) > 0) {
                    showCollectPetDeposit = true;
                }
                var showProRate = false;
                leaseData.prorate_rent = leaseData.prorate_rent / 100
                leaseData.prorate_rent = new Intl.NumberFormat('en', { maximumSignificantDigits: 10 }).format(leaseData.prorate_rent);
                if (leaseData.prorate_rent != null && parseFloat(leaseData.prorate_rent) > 0) {
                    showProRate = true;
                }
                var showIncreaseRent = false;
                leaseData.rent_increase_amount = leaseData.rent_increase_amount / 100
                leaseData.rent_increase_amount = new Intl.NumberFormat('en', { maximumSignificantDigits: 10 }).format(leaseData.rent_increase_amount);
                if (leaseData.rent_increase_amount != null && parseFloat(leaseData.rent_increase_amount) > 0) {
                    showIncreaseRent = true;
                }
                var showChargeSalePercentage = false;
                leaseData.sales_max_amount = leaseData.sales_max_amount / 100
                leaseData.sales_min_amount = leaseData.sales_min_amount / 100
                if (leaseData.sales_max_amount != null && parseFloat(leaseData.sales_max_amount) > 0) {
                    showChargeSalePercentage = true;
                }
                var showPrepaidOption = false;
                if (leaseData.prepaid_end_date != null && leaseData.prepaid_end_date != '') {
                    showPrepaidOption = true;
                }

                leaseData.sales_max_amount = new Intl.NumberFormat('en', { maximumSignificantDigits: 10 }).format(leaseData.sales_max_amount);
                leaseData.sales_min_amount = new Intl.NumberFormat('en', { maximumSignificantDigits: 10 }).format(leaseData.sales_min_amount);

                leaseData.prorate_amount        = leaseData.prorate_rent
                leaseData.sales_percentage      = leaseData.sales_percentage
                leaseData.sales_min             = leaseData.sales_min_amount
                leaseData.sales_max             = leaseData.sales_max_amount
                leaseData.increase_rent_amount  = leaseData.rent_increase_amount
                leaseData.increase_rent_length  = leaseData.rent_increase_in_months
                leaseData.deposit_amount        = leaseData.security_deposit
                leaseData.pet_deposit_amount    = leaseData.pet_deposit
                leaseData.prepaidEndDate == undefined ||
                    leaseData.prepaidEndDate == "Invalid date" && (
                        leaseData.prepaidEndDate = null
                    )

                self.setState({
                    lease: lease,
                    leaseData: leaseData,
                    attachments: response.data[0].attachments,
                    agreement: response.data[0].agreement,
                    tenantArray: response.data[0].tenants,
                    selectedProperty: selectedProperty,
                    selectedUnitId: selectedUnitId,
                    feeDetails: response.data[0].fee,
                    selected_rent_payment_option: leaseData.rent_payment_option,
                    selected_tenant_pay_rent_id: leaseData.tenant_pay_rent_id,
                    signature: response.data[0].signature,
                    completed_signature: response.data[0].completed_signature,
                    hasAllPaidDeposit: response.data[0].security_deposit_all_paid,
                    showCollectDeposit: showCollectDeposit,
                    showCollectPetDeposit: showCollectPetDeposit,
                    showProRate: showProRate,
                    showIncreaseRent: showIncreaseRent,
                    showChargeSalePercentage: showChargeSalePercentage,
                    showPrepaidOption: showPrepaidOption
                });
            });
        } else {
            lease.setLeaseID(0);
            lease.setDefaultState(this);
        }

        jQuery('#effective_date').datepicker({
            changeMonth: true,
            changeYear: true,
            dateFormat: 'yy-mm-dd',
            onSelect: function(e) {
                self.handleEffectiveDateChange(e);
            }
        });

        jQuery('#expiration_date').datepicker({
            changeMonth: true,
            changeYear: true,
            dateFormat: 'yy-mm-dd',
            onSelect: function(e) {
                self.handleLeaseExpirationChange(e);
            }
        });

        jQuery('#collect_rent_date').datepicker({
            changeMonth: true,
            changeYear: true,
            dateFormat: 'yy-mm-dd',
            container: "#move_in_modal",
            onSelect: function(e) {
                self.onCollectRentDateChange(e);
            }
        });

        jQuery('#lease_term_prepaid').datepicker({
            changeMonth: true,
            changeYear: true,
            dateFormat: 'yy-mm-dd',
            onSelect: function(e) {
                self.handlePrepaidEndDateChange(e);
            }
        });

        dropZone.setup(this, 'leaseagreement', this.state.leaseID);
    }

    componentWillUpdate(nextProps, nextState) {
        var self = this;
        if(nextState.leaseData.payment_recurrence_method === undefined || nextState.leaseData.payment_recurrence_method == "") {
            nextState.leaseData.payment_recurrence_method = "month";
        }

        if(lease.didMoveIn) {
            lease.didMoveIn = false;
            lease.setLeaseID(this.state.leaseID);
            lease.getLease(function(response) {
                var selectedProperty = null;
                var selectedUnitId = 0;
                var lease = response.data[0].belongTo;
                if (response.data[0].property) {
                    selectedProperty = {
                        details: response.data[0].property,
                        units: response.data[0].properties_units,
                        photo: response.data[0].property_photo
                    }
                    if (response.data[0].assigned_property_unit) {
                        selectedUnitId = response.data[0].assigned_property_unit.property_unit_id;
                    }
                    lease.property_id = selectedProperty.details.property_id;
                }

                var leaseData = response.data[0].data;
                leaseData.contract_amount = leaseData.contract_amount / 100
                leaseData.contract_amount = new Intl.NumberFormat('en', { maximumSignificantDigits: 10 }).format(leaseData.contract_amount);
                leaseData.rent_payment_option = lease.rent_payment_type;
                if (leaseData.rent_payment_option == 'single') {
                    var tenants = response.data[0].tenants;
                    tenants.forEach(tenant => {
                        if (tenant.tenant.pays_rent == 1) {
                            leaseData.tenant_pay_rent_id = tenant.tenant.tenant_id;
                        }
                    });
                }
                self.setState({
                    lease: lease,
                    leaseData: leaseData,
                    attachments: response.data[0].attachments,
                    agreement: response.data[0].agreement,
                    tenantArray: response.data[0].tenants,
                    selectedProperty: selectedProperty,
                    selectedUnitId: selectedUnitId,
                    feeDetails: response.data[0].fee,
                    selected_rent_payment_option: leaseData.rent_payment_option,
                    selected_tenant_pay_rent_id: leaseData.tenant_pay_rent_id,
                    signature: response.data[0].signature,
                    completed_signature: response.data[0].completed_signature,
                    hasAllPaidDeposit: response.data[0].security_deposit_all_paid,
                });
            });
        }
    }

    componentDidUpdate() {
        var self = this;

        jQuery(".toggle-switch").bootstrapToggle();
        jQuery(".toggle-switch").change(function(e){
            const value = jQuery(e.target).prop('checked');
            self.setState({ notifyTenant: value })
        });

        jQuery(".toggle-switch-request-eSig").bootstrapToggle();
        jQuery(".toggle-switch-request-eSig").change(function(e){
            const value = jQuery(e.target).prop('checked');
            self.setState({
                tenantsMoveInData: update(self.state.tenantsMoveInData, {
                    requestElectronic: {$set: value}
                })
            })
        });

        jQuery('#lease_term_prepaid').datepicker({
            changeMonth: true,
            changeYear: true,
            dateFormat: 'yy-mm-dd',
            onSelect: function(e) {
                self.handlePrepaidEndDateChange(e);
            }
        });
        jQuery('#effective_date_move_in').datepicker({
            changeMonth: true,
            changeYear: true,
            dateFormat: 'yy-mm-dd',
            container: "#move_in_modal",
            onSelect: function(e) {
                self.onEffectiveDateChange(e);
            }
        });
        jQuery('#collect_rent_date').datepicker({
            changeMonth: true,
            changeYear: true,
            dateFormat: 'yy-mm-dd',
            container: "#move_in_modal",
            onSelect: function(e) {
                self.onCollectRentDateChange(e);
            }
        });
        jQuery('#startdaterange').datepicker({
            changeMonth: true,
            changeYear: true,
            dateFormat: 'yy-mm-dd',
            container: "#move_in_modal",
            onSelect: function(e) {
                self.onMoveInDateRangePick(e);
            }
        });
        jQuery('#enddaterange').datepicker({
            changeMonth: true,
            changeYear: true,
            dateFormat: 'yy-mm-dd',
            container: "#move_in_modal",
            onSelect: function(e) {
                self.onMoveOutDateRangePick(e);
            }
        });
    }

    // #  When uploading a new contract, the contract_id will be passed
    triggerUpload(contract_id, type) {
        var self = this;
        if(contract_id != 0) {
            dropZone.setup(this, 'leaseagreement', contract_id, true);
        }

        dropZone.upload(type, function() {
            if(!self.newLease) {
                lease.getLease(function(response) {
                    if (response.data[0]) {
                        var selectedProperty = null;
                        var selectedUnitId = 0;
                        var lease = response.data[0].belongTo;
                        if (response.data[0].property) {
                            selectedProperty = {
                                details: response.data[0].property,
                                units: response.data[0].properties_units,
                                photo: response.data[0].property_photo
                            }
                            if (response.data[0].assigned_property_unit) {
                                selectedUnitId = response.data[0].assigned_property_unit.property_unit_id;
                            }
                            lease.property_id = selectedProperty.details.property_id;
                        }
                        var leaseData = response.data[0].data;
                        leaseData.contract_amount = leaseData.contract_amount / 100
                        leaseData.contract_amount = new Intl.NumberFormat('en', { maximumSignificantDigits: 10 }).format(leaseData.contract_amount);
                        leaseData.rent_payment_option = lease.rent_payment_type;
                        if (leaseData.rent_payment_option == 'single') {
                            var tenants = response.data[0].tenants;
                            tenants.forEach(tenant => {
                                if (tenant.tenant.pays_rent == 1) {
                                    leaseData.tenant_pay_rent_id = tenant.tenant.tenant_id;
                                }
                            });
                        }
                        self.setState({
                            lease: lease,
                            leaseData: leaseData,
                            attachments: response.data[0].attachments,
                            agreement: response.data[0].agreement,
                            tenantArray: response.data[0].tenants,
                            selectedProperty: selectedProperty,
                            selectedUnitId: selectedUnitId,
                            feeDetails: response.data[0].fee,
                            selected_rent_payment_option: leaseData.rent_payment_option,
                            selected_tenant_pay_rent_id: leaseData.tenant_pay_rent_id,
                            signature: response.data[0].signature,
                            completed_signature: response.data[0].completed_signature,
                            hasAllPaidDeposit: response.data[0].security_deposit_all_paid,
                        });
                    }
                });
            }
        });

        const isFilesAdded = dropZone.isFilesAdded();
        if (isFilesAdded == false) {
            if (type == "new_lease") {
                modal.showSuccess("Lease Added!","You can now move tenants in!");
                jQuery(".move-on").on('click',function() {
                    browserHistory.goBack();
                });
            } else {
                modal.showInfo("There is no pending file to upload!", "warning", "top", "center");
            }
        }
    }

    handleTitleChange(e){
        this.setState({
            leaseData: update(this.state.leaseData, {
                title: {$set: e.target.value
                }}
            )
        });
    }

    formatAmount(value) {
        value = value.replace(',', '');
        if(isNaN(value) || value === 0) {
            value = 0;
        } else {
            value = new Intl.NumberFormat('en', { maximumSignificantDigits: 10 }).format(value)
        }

        return value;
    }

    /**
     * Formats money, if not value, return 0
     * @param {*} e
     */
    handleAmountChange(e) {
        this.setState({
            leaseData: update(this.state.leaseData, {
                contract_amount: {$set: e.target.value
                }}
            )
        });
    }

    /**
     * Returns payment select method
     * @param {*} e
     */
    paymentRecurrenceOption(e) {
        this.setState({
            leaseData: update(this.state.leaseData, {
                payment_recurrence_method: {$set: e.target.value
                }}
            )
        });
    }

    handleEffectiveDateChange(value){
        this.setState({
            leaseData: update(this.state.leaseData, {
                effective_date: {$set: value
                }}
            )
        });
    }

    handleRentDueDateChange(value){
        this.setState({
            leaseData: update(this.state.leaseData, {
                rent_due_day: {$set: value.target.value
                }}
            )
        });
    }

    handleLeaseExpirationChange(value){
        this.setState({
            leaseData: update(this.state.leaseData, {
                contract_expiration_date: {$set: value
                }}
            )
        });
    }

    validate() {
        const enteredData = this.state.leaseData;
        const title = enteredData.title;
        const isSalesPercentage = this.state.showChargeSalePercentage;
        const rentDue = enteredData.rent_due_day;
        const termLength = enteredData.term_length;
        const rentPaymentOption = this.state.selected_rent_payment_option;
        const tenantPayRentId = this.state.selected_tenant_pay_rent_id;
        const tenantArray = this.state.tenantArray;
        const filesAdded = dropZone.isFilesAdded();
        const uploadSuccess = dropZone.isUploadSuccess();

        var leaseAmount = enteredData.contract_amount;
        var prorate_amount = enteredData.prorate_amount;
        var sales_percentage = enteredData.sales_percentage;
        var sales_min = enteredData.sales_min;
        var sales_max = enteredData.sales_max;
        var increase_rent_amount = enteredData.increase_rent_amount;
        var deposit_amount = enteredData.deposit_amount;
        var pet_deposit_amount = enteredData.pet_deposit_amount;
        var prepaid_end_date = enteredData.prepaid_end_date;
        if (enteredData.contract_amount) {
            leaseAmount = enteredData.contract_amount.toString().replace(',', '').replace('.', '');
        }
        if (enteredData.prorate_amount) {
            prorate_amount = enteredData.prorate_amount.toString().replace(',', '').replace('.', '');
        }
        if (enteredData.sales_percentage) {
            sales_percentage = enteredData.sales_percentage.toString().replace(',', '').replace('.', '');
        }
        if (enteredData.sales_min) {
            sales_min = enteredData.sales_min.toString().replace(',', '').replace('.', '');
        }
        if (enteredData.sales_max) {
            sales_max = enteredData.sales_max.toString().replace(',', '').replace('.', '');
        }
        if (enteredData.increase_rent_amount) {
            increase_rent_amount = enteredData.increase_rent_amount.toString().replace(',', '').replace('.', '');
        }
        if (enteredData.deposit_amount) {
            deposit_amount = enteredData.deposit_amount.toString().replace(',', '').replace('.', '');
        }
        if (enteredData.pet_deposit_amount) {
            pet_deposit_amount = enteredData.pet_deposit_amount.toString().replace(',', '').replace('.', '');
        }
        if(filesAdded == true && uploadSuccess == false) {
            modal.showInfo("You have pending files that need to be uploaded!", "warning", "top", "center");
            return false;
        }

        if(title === undefined || title.length == 0) {
            modal.showInfo("You need to provide a title for a new lease.", "warning", "top", "center");
            return false;
        }

        if ((leaseAmount === undefined || leaseAmount <= 0) && !isSalesPercentage) {
            modal.showInfo("How much is rent every month?", "warning", "top", "center");
            return false;
        } else if (isNaN(leaseAmount)) {
            modal.showInfo("Please enter a valid rent amount.", "warning", "top", "center");
            return false;
        }

        if(!rentDue || rentDue.length == 0) {
            modal.showInfo("You need to enter a rent due day.", "warning", "top", "center");
            return false;
        }

        if(!termLength) {
            modal.showInfo("We need to know the term length of this lease.", "warning", "top", "center");
            return false;
        }

        if (this.state.showCollectDeposit == true) {
            if (!deposit_amount || deposit_amount <= 0) {
                modal.showInfo("What is the amount of the security deposit?", "warning", "top", "center");
                return false;
            } else if (isNaN(deposit_amount)) {
                modal.showInfo("Please enter a valid deposit amount.", "warning", "top", "center");
                return false;
            }
        }

        if (this.state.showCollectPetDeposit == true) {
            if (!pet_deposit_amount || pet_deposit_amount <= 0) {
                modal.showInfo("What is the amount of the pet deposit?", "warning", "top", "center");
                return false;
            } else if (isNaN(pet_deposit_amount)) {
                modal.showInfo("Please enter a valid deposit amount.", "warning", "top", "center");
                return false;
            }
        }

        if (this.state.showProRate == true) {
            if (!prorate_amount || prorate_amount <= 0) {
                modal.showInfo("What is the prorate amount of this lease?", "warning", "top", "center");
                return false;
            } else if (isNaN(prorate_amount)) {
                modal.showInfo("Please enter a valid prorate amount.", "warning", "top", "center");
                return false;
            }
        }

        if (isSalesPercentage == true) {
            if (!sales_percentage || sales_percentage <= 0) {
                modal.showInfo("What is the sales percentage that will be charged?", "warning", "top", "center");
                return false;
            } else if (isNaN(sales_percentage)) {
                modal.showInfo("Please enter a valid sales percentage.", "warning", "top", "center");
                return false;
            }

            if (!sales_min || sales_min < 0) {
                modal.showInfo("What is the sales minimum price that will be charged?", "warning", "top", "center");
                return false;
            } else if (isNaN(sales_min)) {
                modal.showInfo("Please enter a valid sales minimum price.", "warning", "top", "center");
                return false;
            }

            if (!sales_max || sales_max <= 0) {
                modal.showInfo("What is the sales maximum price that will be charged?", "warning", "top", "center");
                return false;
            } else if (isNaN(sales_max)) {
                modal.showInfo("Please enter a valid sales maximum price.", "warning", "top", "center");
                return false;
            }

            if (sales_min >= sales_max) {
                modal.showInfo("The minimum charge must be smaller than the maximum charge!", "warning", "top", "center");
                return false;
            }
        }

        if (this.state.showIncreaseRent == true) {
            if (!increase_rent_amount || increase_rent_amount <= 0) {
                modal.showInfo("What is the rent amount that will be increased?", "warning", "top", "center");
                return false;
            } else if (isNaN(increase_rent_amount)) {
                modal.showInfo("Please enter a valid rent amount that will be increased.", "warning", "top", "center");
                return false;
            }
        }

        if (this.state.showPrepaidOption == true) {
            if (Math.ceil((moment() - moment(prepaid_end_date)) * 0.001 / 86400) > 1) {
                modal.showInfo("The date for the prepaid end date must be on or after today.", "warning", "top", "center");
                return false;
            }
        }

        if(rentPaymentOption == null && tenantArray.length > 0) {
            modal.showInfo("Specify the rent payment option!", "danger", "top", "center");
            return false;
        }

        if (rentPaymentOption == "single" && tenantPayRentId == null && tenantArray.length > 0) {
            modal.showInfo("Specify a tenant who is responsible for the rent!", "danger", "top", "center");
            return false;
        }

        return true;
    }

    validateOnBoarding() {
        const enteredData = this.state.leaseData;
        const title = enteredData.title;
        const rentDue = enteredData.rent_due_day;
        const termLength = enteredData.term_length;

        var leaseAmount = enteredData.contract_amount;
        var prorate_amount = enteredData.prorate_amount;
        var sales_percentage = enteredData.sales_percentage;
        var sales_min = enteredData.sales_min;
        var sales_max = enteredData.sales_max;
        var increase_rent_amount = enteredData.increase_rent_amount;
        var deposit_amount = enteredData.deposit_amount;
        var pet_deposit_amount = enteredData.pet_deposit_amount;
        if (enteredData.contract_amount) {
            leaseAmount = enteredData.contract_amount.toString().replace(',', '').replace('.', '');
        }
        if (enteredData.prorate_amount) {
            prorate_amount = enteredData.prorate_amount.toString().replace(',', '').replace('.', '');
        }
        if (enteredData.sales_percentage) {
            sales_percentage = enteredData.sales_percentage.toString().replace(',', '').replace('.', '');
        }
        if (enteredData.sales_min) {
            sales_min = enteredData.sales_min.toString().replace(',', '').replace('.', '');
        }
        if (enteredData.sales_max) {
            sales_max = enteredData.sales_max.toString().replace(',', '').replace('.', '');
        }
        if (enteredData.increase_rent_amount) {
            increase_rent_amount = enteredData.increase_rent_amount.toString().replace(',', '').replace('.', '');
        }
        if (enteredData.deposit_amount) {
            deposit_amount = enteredData.deposit_amount.toString().replace(',', '').replace('.', '');
        }
        if (enteredData.pet_deposit_amount) {
            pet_deposit_amount = enteredData.pet_deposit_amount.toString().replace(',', '').replace('.', '');
        }

        if(title === undefined || title.length == 0) {
            modal.showInfo("You need to provide a title for a new lease.", "warning", "top", "center");
            return false;
        }

        if (leaseAmount === undefined || leaseAmount <= 0) {
            modal.showInfo("How much is rent every month?", "warning", "top", "center");
            return false;
        } else if (isNaN(leaseAmount)) {
            modal.showInfo("Please enter a valid rent amount.", "warning", "top", "center");
            return false;
        }

        if(!rentDue || rentDue.length == 0) {
            modal.showInfo("What day each month is rent due?", "warning", "top", "center");
            return false;
        }

        if(!termLength) {
            modal.showInfo("How many months is this lease?", "warning", "top", "center");
            return false;
        }

        if (this.state.showCollectDeposit == true) {
            if (!deposit_amount || deposit_amount <= 0) {
                modal.showInfo("What is the amount of the security deposit?", "warning", "top", "center");
                return false;
            } else if (isNaN(deposit_amount)) {
                modal.showInfo("Please enter a valid deposit amount.", "warning", "top", "center");
                return false;
            }
        }

        if (this.state.showCollectPetDeposit == true) {
            if (!pet_deposit_amount || pet_deposit_amount <= 0) {
                modal.showInfo("What is the amount of the pet deposit?", "warning", "top", "center");
                return false;
            } else if (isNaN(pet_deposit_amount)) {
                modal.showInfo("Please enter a valid deposit amount.", "warning", "top", "center");
                return false;
            }
        }

        if (this.state.showProRate == true) {
            if (!prorate_amount || prorate_amount <= 0) {
                modal.showInfo("What is the prorate amount of this lease?", "warning", "top", "center");
                return false;
            } else if (isNaN(prorate_amount)) {
                modal.showInfo("Please enter a valid prorate amount.", "warning", "top", "center");
                return false;
            }
        }

        if (this.state.showChargeSalePercentage == true) {
            if (!sales_percentage || sales_percentage <= 0) {
                modal.showInfo("What is the sales percentage that will be charged?", "warning", "top", "center");
                return false;
            } else if (isNaN(sales_percentage)) {
                modal.showInfo("Please enter a valid sales percentage.", "warning", "top", "center");
                return false;
            }

            if (!sales_min || sales_min <= 0) {
                modal.showInfo("What is the sales minimum price that will be charged?", "warning", "top", "center");
                return false;
            } else if (isNaN(sales_min)) {
                modal.showInfo("Please enter a valid sales minimum price.", "warning", "top", "center");
                return false;
            }

            if (!sales_max || sales_max <= 0) {
                modal.showInfo("What is the sales maximum price that will be charged?", "warning", "top", "center");
                return false;
            } else if (isNaN(sales_max)) {
                modal.showInfo("Please enter a valid sales maximum price.", "warning", "top", "center");
                return false;
            }

            if (sales_min >= sales_max) {
                modal.showInfo("The minimum charge must be smaller than the maximum charge!", "warning", "top", "center");
                return false;
            }
        }

        if (this.state.showIncreaseRent == true) {
            if (!increase_rent_amount || increase_rent_amount <= 0) {
                modal.showInfo("What is the rent amount that will be increased?", "warning", "top", "center");
                return false;
            } else if (isNaN(increase_rent_amount)) {
                modal.showInfo("Please enter a valid rent amount that will be increased.", "warning", "top", "center");
                return false;
            }
        }

        return true;
    }

    handleSaveLeaseData(e){
        if(!this.validate()) {
            return;
        }

        if (this.state.invoicingActive == "active") {
            var continueSave = this.refs.leaseInvoice.onSaveLeaseInvoices();
            if (continueSave == true) {
                lease.saveLease(this);
            }
        } else {
            lease.saveLease(this);
        }
    }

    handleSaveLeaseDataOnboarding(e){
        if(!this.validateOnBoarding()) {
            return;
        }

        lease.saveLeaseOnboarding(this);
    }

    handleDeleteLease(e){
        lease.deleteLease(this);
    }

    handleDeleteDocument(attachment) {
        documents.deleteDocument(attachment.id, function() {
            lease.getLease();
        });
    }

    buildDaysSelect(rentDay) {
        var days = [];
        for(var i = 1; i <= 31; i++) {
            days.push(i);
        }

        return days.map((day) => (
            rentDay == day ? (
                <option key={day} value={day} defaultValue>{day}</option>
            ) : (
                <option key={day} value={day}>{day}</option>
            )
        ));
    }

    handleFeeChange(e) {
        this.setState({
            lease: update(this.state.lease, {
                fee_id: {$set: e.target.value
                }}
            )
        });
    }

    handleBuildingChange(e, building_data) {
        if(building_data) {
            this.setState({
                lease: update(this.state.lease, {
                    building_id: {$set: e.target.value,
                    }}
                ),
                leaseData: update(this.state.leaseData, {
                    address: {$set: building_data.data.building_address},
                    city: {$set: building_data.data.building_city},
                    state: {$set: building_data.data.building_state},
                    zipcode: {$set: building_data.data.building_zip}
                })
            });
        } else {
            this.setState({
                lease: update(this.state.lease, {
                    building_id: {$set: e.target.value}
                }),
                leaseData: update(this.state.leaseData, {
                    address: {$set: ''},
                    city: {$set: ''},
                    state: {$set: ''},
                    zipcode: {$set: ''}
                })
            });
        }
    }

    handleSpaceChange(e) {
        this.setState({
            lease: update(this.state.lease, {
                space_id: {$set: e.target.value
                }}
            )
        });
    }

    onBedroomType(e) {
        this.setState({
            lease: update(this.state.lease, {
                contract_bedroom_type: {$set: e.target.value
                }}
            )
        });
    }

    onBathroomType(e) {
        this.setState({
            lease: update(this.state.lease, {
                contract_bathroom_type: {$set: e.target.value
                }}
            )
        });
    }

    handleAddressChange(e) {
        this.setState({
            leaseData: update(this.state.leaseData, {
                address: {$set: e.target.value
                }}
            )
        });
    }

    handleCityChange(e) {
        this.setState({
            leaseData: update(this.state.leaseData, {
                city: {$set: e.target.value
                }}
            )
        });
    }

    handleStateChange(e) {
        this.setState({
            leaseData: update(this.state.leaseData, {
                state: {$set: e.target.value
                }}
            )
        });
    }

    handlePropertyChange(e) {
        var self = this;
        var value = e.target.value;
        if (value == 0) {
            self.setState({
                lease: update(self.state.lease, {
                    property_id: {$set: value
                    }}
                ),
                selectedProperty: null,
                selectedUnitId: 0
            });
        } else {
            property.getProperty(value, function(response) {
                self.setState({
                    lease: update(self.state.lease, {
                        property_id: {$set: value
                        }}
                    ),
                    selectedProperty: response.data,
                    selectedUnitId: 0
                });
            });
        }
    }

    handleZipcodeChange(e) {
        this.setState({
            leaseData: update(this.state.leaseData, {
                zipcode: {$set: e.target.value
                }}
            )
        });
    }

    handleGroupSelect(e) {
        this.setState({
            lease: update(this.state.lease, {
                building_group_id: {$set: e.target.value
                }}
            )
        });
    }

    handleSqftChange(e) {
        this.setState({
            leaseData: update(this.state.leaseData, {
                sqft: {$set: e.target.value
                }}
            )
        });
    }

    handleQbCustomerRefChange(e) {
        this.setState({
            lease: update(this.state.lease, {
                qb_customer_ref: {$set: e.target.value
                }}
            )
        });
    }

    handleQbItemRefChange(e) {
        this.setState({
            lease: update(this.state.lease, {
                qb_item_ref: {$set: e.target.value
                }}
            )
        });
    }

    onTermLengthChange(e) {
        var expirationDate = this.state.leaseData.effective_date;
        const termLength = e.target.value;
        if(expirationDate != '') {
            expirationDate = moment(expirationDate).add(termLength, 'month').format("Y-MM-DD");
        }

        this.setState({
            leaseData: update(this.state.leaseData, {
                contract_expiration_date: {$set: expirationDate},
                term_length: {$set: termLength}
            })
        });
    }

    buildTermsSelect() {
        var terms = [];
        for(var i = 1; i <= 18; i++) {
            terms.push(i);
        }
        for (var i = 24; i <= 72; i += 6) {
            terms.push(i)
        }

        return terms.map((term) => (
            <option key={'term-' + term} value={term}>{term}</option>
        ));
    }

    renderAttachments(attachments) {
        var self = this;
        if (attachments !== null) {
            if(attachments.length > 0) {
                var attachmentsLength = attachments.length
                for (var i = 0; i < attachmentsLength; i++) {
                    if (attachments[i].content_type == "pdf") {
                        var temp = attachments[i]
                        attachments.splice(i, 1);
                        attachments.push(temp)
                    }
                }
                return attachments.map((attachment, index) => (
                    <Attachment key={index} attachment={attachment} deleteFunc={self.handleDeleteDocument.bind(self)}/>
                ));
            }
        }
        else return (<p>No Documents Found, try adding some! </p>);
    }

    selectedUnit(id) {
        this.setState({
            selectedUnitId: id
        })
    }

    renderAgreement(agreement) {
        var self = this;
        if (agreement !== null) {
            return <Attachment attachment={agreement} deleteFunc={self.handleDeleteDocument.bind(self)}/>
        }
        else return null;
        // else return (<p style={{textAlign: 'center'}}>No agreement found, add one for your tenants to sign. </p>);
    }

    onRentPaymentOptionChange(e) {
        if (e.target.value == "single") {
            this.setState({
                selected_rent_payment_option: "single",
                leaseData: update(this.state.leaseData, {
                    tenant_pay_rent_id: {$set: 0}
                })
            })
            jQuery("#tenant-rent-responsible").attr("disabled", false);
            jQuery("#tenant-rent-responsible-moveout").attr("disabled", false);
        } else if (e.target.value == "split") {
            this.setState({
                selected_rent_payment_option: "split",
            })
            jQuery("#tenant-rent-responsible").attr("disabled", true);
            jQuery("#tenant-rent-responsible-moveout").attr("disabled", true);
        } else {
            this.setState({
                selected_rent_payment_option: null,
            })
            jQuery("#tenant-rent-responsible").attr("disabled", true);
            jQuery("#tenant-rent-responsible-moveout").attr("disabled", true);
        }
    }

    onResponsibleTenantChange(e) {
        if (e.target.value == "Default") {
            this.setState({
                selected_tenant_pay_rent_id: null,
            })
        } else {
            this.setState({
                selected_tenant_pay_rent_id: e.target.value,
            })
        }
    }

    onEffectiveDateChange(value) {
        this.setState({
            tenantsMoveInData: update(this.state.tenantsMoveInData, {
                effectiveDate: {$set: value}
            })
        });
    }

    onExpirationDateChange(value) {
        this.setState({
            tenantsMoveInData: update(this.state.tenantsMoveInData, {
                expirationDate: {$set: value}
            })
        });
    }

    onSecurityDepositChange(e) {
        var self = this;
        self.setState({
            tenantsMoveInData: update(self.state.tenantsMoveInData, {
                securityDeposit: {$set: e.target.value}
            })
        })
    }

    onPetDepositChange(e) {
        var self = this;
        self.setState({
            tenantsMoveInData: update(self.state.tenantsMoveInData, {
                petDeposit: {$set: e.target.value}
            })
        })
    }

    onRentChange(e) {
        var self = this;
        self.setState({
            tenantsMoveInData: update(self.state.tenantsMoveInData, {
                rentAmount: {$set: e.target.value}
            })
        })
    }

    onCollectRentDateChange(value) {
        this.setState({
            tenantsMoveInData: update(this.state.tenantsMoveInData, {
                collectRentDate: {$set: value}
            })
        });
    }

    onTermLengthMoveInChange(e) {
        var self = this;
        var expirationDate = this.state.tenantsMoveInData.effectiveDate;
        const termLength = e.target.value;
        if(expirationDate != '') {
            expirationDate = moment(expirationDate).add(termLength, 'month').format("Y-MM-DD");
        }

        this.setState({
            tenantsMoveInData: update(self.state.tenantsMoveInData, {
                termLength: {$set: termLength},
                expirationDate: {$set: expirationDate}
            })
        });
    }

    onRentDueDayChange(e) {
        var self = this;
        this.setState({
            tenantsMoveInData: update(self.state.tenantsMoveInData, {
                rentDueDay: {$set: e.target.value},
            })
        });
    }

    onRentPaymentOptionMoveInChange(e) {
        var self = this;
        if (e.target.value == "single") {
            this.setState({
                tenantsMoveInData: update(self.state.tenantsMoveInData, {
                    rentPaymentOption: {$set: "single"},
                })
            })
        } else if (e.target.value == "split") {
            this.setState({
                tenantsMoveInData: update(self.state.tenantsMoveInData, {
                    rentPaymentOption: {$set: "split"},
                })
            })
        } else {
            this.setState({
                tenantsMoveInData: update(self.state.tenantsMoveInData, {
                    rentPaymentOption: {$set: null},
                })
            })
        }
    }

    onResponsibleTenantMoveInChange(e) {
        var self = this;
        if (e.target.value == "Default") {
            this.setState({
                tenantsMoveInData: update(self.state.tenantsMoveInData, {
                    tenantPayRentId: {$set: null},
                })
            })
        } else {
            this.setState({
                tenantsMoveInData: update(self.state.tenantsMoveInData, {
                    tenantPayRentId: {$set: e.target.value},
                })
            })
        }
    }

    onMoveInDateRangePick(start) {
        var self = this;
        this.setState({
            tenantsMoveInData: update(self.state.tenantsMoveInData, {
                startDate: {$set: start}
            })
        });
    }

    onMoveOutDateRangePick(end) {
        var self = this;
        this.setState({
            tenantsMoveInData: update(self.state.tenantsMoveInData, {
                endDate: {$set: end},
            })
        });
    }

    onHandlingSecurityDepositChange(e) {
        var self = this;
        this.setState({
            tenantsMoveInData: update(self.state.tenantsMoveInData, {
                collectSecurityDeposit: {$set: e.target.value},
            })
        });
    }

    onHandlingPetDepositChange(e) {
        var self = this;
        this.setState({
            tenantsMoveInData: update(self.state.tenantsMoveInData, {
                collectPetDeposit: {$set: e.target.value},
            })
        });
    }

    onHandlingRentCollectionChange(e) {
        var self = this;
        this.setState({
            tenantsMoveInData: update(self.state.tenantsMoveInData, {
                collectRentNow: {$set: e.target.value},
            })
        });
    }

    handleOpenMoveInModal() {
        var self = this;

        jQuery(".toggle-switch-request-eSig").bootstrapToggle();
        // TODO figure out why onChange reactjs event does not trigger
        jQuery(".toggle-switch-request-eSig").change(function(e){
            const value = jQuery(e.target).prop('checked');
            self.setState({
                tenantsMoveInData: update(self.state.tenantsMoveInData, {
                    requestElectronic: {$set: value}
                })
            })

            if(value) {
                modal.showInfo("Tenant will receive a link for electronic signature of the lease agreement attached.", "warning", "top", "center");
            } else {
                modal.showInfo("Tenant will be automatically moved in without request for signature.", "warning", "top", "center");
            }
        });

        lease.setLeaseID(this.state.leaseID);
        lease.getLease(function(response) {
            var expirationDate   = self.state.tenantsMoveInData.effectiveDate;
            const termLength     = response.data[0].data.term_length;
            if(expirationDate != '') {
                expirationDate = moment(expirationDate).add(termLength, 'month').format("Y-MM-DD");
            }
            self.setState({
                tenantsMoveInData: update(self.state.tenantsMoveInData, {
                    rentAmount: {$set: self.formatAmount((response.data[0].data.contract_amount / 100).toString())},
                    rentDueDay: {$set: response.data[0].data.rent_due_day},
                    securityDeposit: {$set: self.formatAmount((response.data[0].data.security_deposit / 100).toString())},
                    petDeposit: {$set: self.formatAmount((response.data[0].data.pet_deposit / 100).toString())},
                    collectRentDate: {$set: moment().format("Y-MM-DD")},
                    termLength: {$set: termLength},
                    expirationDate: {$set: expirationDate}
                })
            });
        });

        this.setState({ showMoveInModal: true });
    }

    handleOpenMoveOutModal() {
        var self = this;
        lease.setLeaseID(this.state.leaseID);
        lease.getLease(function(response) {
            if (response.data[0].belongTo.rent_payment_type == 'single') {
                var tenants = response.data[0].tenants;
                tenants.forEach(tenant => {
                    if (tenant.tenant.pays_rent == 1) {
                        self.setState({
                            leaseData: update(self.state.leaseData, {
                                tenant_pay_rent_id: {$set: tenant.tenant.tenant_id},
                            })
                        });
                    }
                });
            }
            self.setState({
                tenantArray: response.data[0].tenants,
            });
        });
        this.setState({ showMoveOutModal: true });
    }

    handleCloseMoveInModal(didUpdate) {
        this.setState({ showMoveInModal: false });
        if (didUpdate == true) {
            browserHistory.replace('/lease/' + this.state.leaseID);
        }
    }

    handleCloseMoveOutModal(didUpdate) {
        this.setState({ showMoveOutModal: false });
        if (didUpdate == true) {
            browserHistory.replace('/leases');
        }
    }

    sortTenantSelectMoveIn(e) {
        var self = this;
        var tenant_name = e.target.selectedOptions[0].text
        var tenant_id = e.target.value;
        var tenantArr = [];
        var rentPaymentOption = this.state.tenantsMoveInData.rentPaymentOption;
        var tenantPayRentId = this.state.tenantsMoveInData.tenantPayRentId;

        this.setState({
            tenantsMoveInData: update(self.state.tenantsMoveInData, {
                tenant_id: {$set: tenant_id},
            })
        });

        if (tenant_id != 0) {
            if (this.state.tenantsMoveInData.tenantsIdList.indexOf(tenant_id) < 0) {
                tenantArr.push(tenant_id)
                tenantArr.push(tenant_name)

                if (this.state.tenantsMoveInData.totalSelectedTenants == 0) {
                    rentPaymentOption = "single";
                    tenantPayRentId = tenant_id;
                }

                this.setState({
                    tenantsMoveInData: update(self.state.tenantsMoveInData, {
                        tenantsIdList: {$set: self.state.tenantsMoveInData.tenantsIdList.concat([tenant_id])},
                        tenantsList: {$set: [
                            ...self.state.tenantsMoveInData.tenantsList,
                            tenantArr
                        ]},
                        totalSelectedTenants: {$set: self.state.tenantsMoveInData.totalSelectedTenants + 1},
                        rentPaymentOption: {$set: rentPaymentOption},
                        tenantPayRentId: {$set: tenantPayRentId},
                    })
                })
            } else {
                modal.showInfo("Tenant has already been added!", "warning", "top", "center")
            }
        }
    }

    sortTenantSelectMoveOut(e) {
        var self = this;
        var tenant_name = e.target.selectedOptions[0].text
        var tenantId = e.target.value;
        var tenantArr = [];
        var tenantsMoveOutData = this.state.tenantsMoveOutData;

        if (tenantId != "Default") {
            if (tenantsMoveOutData.tenantsIdList.indexOf(tenantId) < 0) {
                tenantArr.push(tenantId)
                tenantArr.push(tenant_name)

                this.setState({
                    tenantsMoveOutData: update(tenantsMoveOutData, {
                        tenantsIdList: {$set: tenantsMoveOutData.tenantsIdList.concat([tenantId])},
                        tenantsList: {$set: [
                            ...tenantsMoveOutData.tenantsList,
                            tenantArr
                        ]},
                    }),
                    didAddTenant: true,
                })

                if ((this.state.tenantArray.length - tenantsMoveOutData.tenantsIdList.length) == 2) {
                    var remainingTenantId = 0;
                    this.state.tenantArray.map(function(tenant) {
                        if (tenant.tenant.tenant_id != tenantId && tenantsMoveOutData.tenantsIdList.indexOf(tenant.tenant.tenant_id) < 0) {
                            remainingTenantId = tenant.tenant.tenant_id
                        }
                    })
                    this.setState({
                        selected_rent_payment_option: "single",
                        selected_tenant_pay_rent_id: remainingTenantId,
                        leaseData: update(self.state.leaseData, {
                            rent_payment_option: {$set: "single"},
                            tenant_pay_rent_id: {$set: remainingTenantId},
                        }),
                    })
                }
            } else {
                modal.showInfo("Tenant has already been added!", "warning", "top", "center")
            }
        }
    }

    validateMoveIn() {
        const monthDifference = moment(new Date(this.state.tenantsMoveInData.endDate)).diff(new Date(this.state.tenantsMoveInData.startDate), 'months', false);
        const tenantsIdList = this.state.tenantsMoveInData.tenantsIdList;
        const rentAmount = this.state.tenantsMoveInData.rentAmount.toString().replace(',', '').replace('.', '');
        const effectiveDate = this.state.tenantsMoveInData.effectiveDate;
        const expirationDate = this.state.tenantsMoveInData.expirationDate;
        const rentDueDay = this.state.tenantsMoveInData.rentDueDay;
        const requestElectronic = this.state.tenantsMoveInData.requestElectronic;
        const rentPaymentOption = this.state.tenantsMoveInData.rentPaymentOption;
        const tenantPayRentId = this.state.tenantsMoveInData.tenantPayRentId;
        const collectRentDate = this.state.tenantsMoveInData.collectRentDate;
        const securityDeposit = this.state.tenantsMoveInData.securityDeposit.toString().replace(',', '').replace('.', '');
        const petDeposit = this.state.tenantsMoveInData.petDeposit.toString().replace(',', '').replace('.', '');
        const isSalesPercentage = this.state.showChargeSalePercentage;
        if (monthDifference <= 0) {
            modal.showInfo("Please select a date range for when the tenant(s) move in and move out.", "danger", "top", "center");
            return false;
        } else if (!tenantsIdList.length) {
            modal.showInfo("Select at least 1 tenant to move in!", "danger", "top", "center");
            return false;
        } else if (rentPaymentOption == null) {
            modal.showInfo("Specify the rent payment option!", "danger", "top", "center");
            return false;
        } else if (rentPaymentOption == "single" && tenantPayRentId == null) {
            modal.showInfo("Specify a tenant who is responsible for the rent!", "danger", "top", "center");
            return false;
        } else if ((!rentAmount || rentAmount <= 0) && !isSalesPercentage) {
            modal.showInfo("Enter the amount due for the rent.", "warning", "top", "center");
            return false;
        } else if (isNaN(rentAmount)) {
            modal.showInfo("Please enter a valid amount due for the rent.", "warning", "top", "center");
            return false;
        } else if (isNaN(securityDeposit)) {
            modal.showInfo("Please enter a valid security deposit amount.", "warning", "top", "center");
            return false;
        } else if (isNaN(petDeposit)) {
            modal.showInfo("Please enter a valid pet deposit amount.", "warning", "top", "center");
            return false;
        } else if (rentDueDay == 0) {
            modal.showInfo("What day of the month is the rent due?", "danger", "top", "center");
            return false;
        } else if (effectiveDate == '') {
            modal.showInfo("Enter the date the lease becomes active.", "danger", "top", "center");
            return false;
        } else if (Math.ceil((moment() - moment(collectRentDate)) * 0.001 / 86400) > 1) {
            modal.showInfo("The date to collect the current rent must be on or after today.", "danger", "top", "center");
            return false;
        } else if (expirationDate == '') {
            modal.showInfo("Enter the lease's expiration date.", "danger", "top", "center");
            return false;
        } else if (this.state.agreement == null && requestElectronic) {
            modal.showInfo("You have no agreement uploaded and cannot request electronic signatures.", "danger", "top", "center");
            return false;
        }

        return true;
    }

    validateMoveOut(selectedTenantPayRentName) {
        const tenantsIdList = this.state.tenantsMoveOutData.tenantsIdList;
        const rentPaymentOption = this.state.selected_rent_payment_option;
        const tenantPayRentId = this.state.selected_tenant_pay_rent_id;
        const tenantArray = this.state.tenantArray;

        if (!tenantsIdList.length) {
            modal.showInfo("Select at least 1 tenant to move out!", "danger", "top", "center");
            return false;
        } else if (tenantsIdList.length > 0) {
            if (rentPaymentOption == null && tenantArray.length > 0) {
                modal.showInfo("Specify the rent payment option!", "danger", "top", "center");
                return false;
            }

            if ((tenantArray.length - tenantsIdList.length) == 1 && rentPaymentOption == "split") {
                modal.showInfo("Specify the rent payment option!", "danger", "top", "center");
                return false;
            }

            if (rentPaymentOption == "single" && tenantPayRentId == null && tenantArray.length > 0) {
                modal.showInfo("Specify a tenant who is responsible for the rent!", "danger", "top", "center");
                return false;
            }

            if ((tenantArray.length - tenantsIdList.length) > 0 && rentPaymentOption == "single") {
                var invalid = false;
                tenantsIdList.map(function(item) {
                    if (item == tenantPayRentId) {
                        modal.showInfo("You are moving out " + selectedTenantPayRentName + " who will be responsible for the rent. Please remove that tenant out of the selected list or choose a new primary tenant.", "danger", "top", "center");
                        invalid = true;
                        return;
                    }
                })
                if (invalid == true) {
                    return false;
                }
            }
        }

        return true;
    }

    moveInFunction(){
        var self               = this;
        var tenantData         = this.state.tenantsMoveInData;
        tenantData.term_length = moment(new Date(this.state.tenantsMoveInData.endDate)).diff(new Date(this.state.tenantsMoveInData.startDate), 'months', false);
        const leaseId          = this.state.leaseID;

        lease.moveIn(leaseId, tenantData, function(response) {
            if (tenantData.requestElectronic) {
                modal.showInfo("Agreement sent for signature.", "success", "top", "center");
            } else {
                modal.showInfo("Tenant(s) successfully moved in!", "success", "top", "center");
            }
            self.handleCloseMoveInModal(true);
        });
    }

    moveIn(e){
        var self = this;
        if(!this.validateMoveIn()) {
            return;
        }

        const tenantsList = this.state.tenantsMoveInData.tenantsList;
        leases.getLeases("0", null, function(response) {
            var warning = false;
            response.data.map(function(item) {
                if (item.meta_data.length > 0) {
                    item.meta_data.map(function(tenant) {
                        var tenantName = tenant.tenant_firstname + " " + tenant.tenant_lastname
                        tenantsList.map(function(curTenant){
                            if (curTenant[1] == tenantName) {
                                warning = true;
                                return;
                            }
                        })
                    })
                }
            })
            if (warning == true) {
                modal.showDangerModalWithOK("Warning!","You are about to move in tenant(s) that might belong to another lease. Are you sure to continue?","Yes");
                jQuery(".move-on").on('click',function() {
                    self.moveInFunction();
                });
            } else {
                self.moveInFunction();
            }
        });
    }

    moveOut(selectedTenantPayRentName) {
        var self = this;
        if(!this.validateMoveOut(selectedTenantPayRentName)) {
            return;
        }
        const leaseId = this.state.tenantsMoveOutData.leaseId;
        const tenantsIdArr = this.state.tenantsMoveOutData.tenantsIdList;
        const tenantsList = this.state.tenantsMoveOutData.tenantsList;

        modal.showDangerModalWithOK("Warning!", "Are you sure you want to remove the selected tenant(s) out of this lease?","Yes");
        jQuery(".move-on").on('click',function() {
            for (var i = 0; i < tenantsIdArr.length; i++) {
                lease.moveOut(leaseId, tenantsIdArr[i], tenantsList[i][1])
            }
            lease.saveLease(self);
            self.handleCloseMoveOutModal(true);
        });
    }

    handleRemoveTenantMoveIn(tenantID){
        var tenantsMoveInData = this.state.tenantsMoveInData;
        var remainingTenantId = 0;

        if (tenantsMoveInData.totalSelectedTenants - 1 == 0) {
            this.setState({
                tenantsMoveInData: update(tenantsMoveInData, {
                    rentPaymentOption: {$set: null},
                    tenantPayRentId: {$set: null}
                })
            });
        } else if (tenantsMoveInData.totalSelectedTenants - 1 == 1) {
            tenantsMoveInData.tenantsIdList.map(function(id) {
                if (id != tenantID) {
                    remainingTenantId = id
                }
            })
            this.setState({
                tenantsMoveInData: update(tenantsMoveInData, {
                    rentPaymentOption: {$set: "single"},
                    tenantPayRentId: {$set: remainingTenantId}
                })
            });
        }

        tenantsMoveInData.tenantsIdList.map((id, index) => {
            if (id == tenantID) {
                tenantsMoveInData.tenantsIdList.splice(index, 1);
                tenantsMoveInData.tenantsList.splice(index, 1);
                this.forceUpdate();
            }
        })

        this.setState({
            tenantsMoveInData: update(tenantsMoveInData, {
                totalSelectedTenants: {$set: tenantsMoveInData.totalSelectedTenants - 1},
            })
        });
    }

    handleRemoveTenantMoveOut(tenantID){
        var tenantsMoveOutData = this.state.tenantsMoveOutData;
        tenantsMoveOutData.tenantsIdList.map((id, index) => {
            if (id == tenantID) {
                tenantsMoveOutData.tenantsIdList.splice(index, 1);
                tenantsMoveOutData.tenantsList.splice(index, 1);

                if (tenantsMoveOutData.tenantsIdList.length == 0) {
                    this.setState({
                        didAddTenant: false
                    })
                } else {
                    this.setState({
                        didAddTenant: true
                    })
                }
                this.forceUpdate();
            }
        })
    }

    onRequestRenewal() {
        const leaseID = this.state.leaseID;
        modal.showDangerModalWithOK("Warning!","You are about to renew this lease for the same amount of terms. Do you want to continue?","Yes");
        jQuery(".move-on").on('click',function() {
            lease.requestLeaseRenewal(leaseID);
            browserHistory.replace('/lease/' + leaseID);
        });
    }

    onRequestDeposit() {
        const leaseID = this.state.leaseID;
        lease.requestLeaseDeposit(leaseID)
        browserHistory.replace('/lease/' + leaseID);
    }

    onRequestESig() {
        const leaseID = this.state.leaseID;

        if (this.state.agreement == null) {
            modal.showInfo("To request a signature, you must upload an agreement to this lease!", "warning", "top", "center")
        } else {
            lease.requestLeaseESig(leaseID)
            browserHistory.replace('/lease/' + leaseID);
        }
    }

    checkLeaseStatus(leaseExpirationDate) {
        var monthDiff = leaseExpirationDate.diff(moment(), "months")
        var dayDiff = leaseExpirationDate.diff(moment(), "days") + 1

        if (monthDiff > 1) {
            return "Expiring in " + monthDiff + " months!"
        } else if (monthDiff == 1) {
            return "Expiring in 1 month!"
        } else {
            if(dayDiff > 1) {
                return "Expiring in " + dayDiff + " days!"
            } else if (dayDiff == 1) {
                return "Expiring in 1 day!"
            } else {
                return "Expired!"
            }
        }
    }

    handleProrateAmountChange(e) {
        this.setState({
            leaseData: update(this.state.leaseData, {
                prorate_amount: {$set: e.target.value}
            })
        })
    }

    handleSalesPercentageChange(e) {
        this.setState({
            leaseData: update(this.state.leaseData, {
                sales_percentage: {$set: e.target.value}
            })
        })
    }

    handleSalesMinChange(e) {
        this.setState({
            leaseData: update(this.state.leaseData, {
                sales_min: {$set: e.target.value}
            })
        })
    }

    handleSalesMaxChange(e) {
        this.setState({
            leaseData: update(this.state.leaseData, {
                sales_max: {$set: e.target.value}
            })
        })
    }

    handleIncreaseRentAmountChange(e) {
        this.setState({
            leaseData: update(this.state.leaseData, {
                increase_rent_amount: {$set: e.target.value}
            })
        })
    }

    handleIncreaseRentLengthChange(e) {
        this.setState({
            leaseData: update(this.state.leaseData, {
                increase_rent_length: {$set: e.target.value}
            })
        })
    }

    handleDepositAmountChange(e){
        this.setState({
            leaseData: update(this.state.leaseData, {
                deposit_amount: {$set: e.target.value}
            })
        })
    }

    handlePetDepositAmountChange(e){
        this.setState({
            leaseData: update(this.state.leaseData, {
                pet_deposit_amount: {$set: e.target.value}
            })
        })
    }

    handlePrepaidEndDateChange(value) {
        this.setState({
            leaseData: update(this.state.leaseData, {
                prepaid_end_date: {$set: value}
            })
        })
    }

    onProRateClick() {
        var amount = this.state.leaseData.prorate_amount;
        if (this.state.showProRate) {
            amount = 0;
        }
        this.setState({
            showProRate: !this.state.showProRate,
            leaseData: update(this.state.leaseData, {
                prorate_amount: {$set: amount}
            })
        })
    }

    onChargePercentageClick() {
        var min = this.state.leaseData.sales_min;
        var max = this.state.leaseData.sales_max;
        var percentage = this.state.leaseData.sales_percentage;
        if (this.state.showChargeSalePercentage) {
            min = 0;
            max = 0;
            percentage = 0;
        }
        this.setState({
            showChargeSalePercentage: !this.state.showChargeSalePercentage,
            leaseData: update(this.state.leaseData, {
                sales_percentage: {$set: percentage},
                sales_min: {$set: min},
                sales_max: {$set: max}
            })
        })
    }

    onIncreaseRentClick() {
        var amount = this.state.leaseData.increase_rent_amount;
        var length = this.state.leaseData.increase_rent_length;
        if (this.state.showIncreaseRent) {
            amount = 0;
            length = 1;
        }
        this.setState({
            showIncreaseRent: !this.state.showIncreaseRent,
            leaseData: update(this.state.leaseData, {
                increase_rent_amount: {$set: amount},
                increase_rent_length: {$set: length}
            })
        })
    }

    onCollectSecurityDepositClick() {
        var deposit = this.state.leaseData.deposit_amount;
        if (this.state.showCollectDeposit) {
            deposit = 0;
        }
        this.setState({
            showCollectDeposit: !this.state.showCollectDeposit,
            leaseData: update(this.state.leaseData, {
                deposit_amount: {$set: deposit}
            })
        });
    }
    onCollectPetDepositClick() {
        var pet_deposit = this.state.leaseData.pet_deposit_amount;
        if (this.state.showCollectPetDeposit) {
            pet_deposit = 0;
        }
        this.setState({
            showCollectPetDeposit: !this.state.showCollectPetDeposit,
            leaseData: update(this.state.leaseData, {
                pet_deposit_amount: {$set: pet_deposit}
            })
        });
    }
    onSetPrepaidOptionClick() {
        var prepaidEndDate = this.state.leaseData.prepaid_end_date;
        var showPrepaidOption = !this.state.showPrepaidOption;
        if (showPrepaidOption) {
            prepaidEndDate = moment().format("Y-MM-DD");
        } else {
            prepaidEndDate = null;
        }

        this.setState({
            showPrepaidOption: showPrepaidOption,
            leaseData: update(this.state.leaseData, {
                prepaid_end_date: {$set: prepaidEndDate}
            })
        });
    }

    render(){
        var leaseData = this.state.leaseData;
        const self = this;
        const agreement = this.renderAgreement(this.state.agreement);
        const newLease = this.props.newLease;
        const tenantArray = this.state.tenantArray;
        const daysOptions = this.buildDaysSelect(leaseData.rent_due_day);
        const leaseName = this.state.leaseData.title;
        const termOptions = this.buildTermsSelect();
        const termLength = this.state.leaseData.term_length;
        const qbItemRef = this.state.lease.qb_item_ref;
        const qbCustomerRef = this.state.lease.qb_customer_ref;
        const property_id = this.state.lease.property_id;
        const selectedProperty = this.state.selectedProperty;
        const selectedUnitId = this.state.selectedUnitId;
        const notifyTenant = this.state.notifyTenant;
        const fee = this.state.lease.fee_id;
        const feeDetails =  this.state.feeDetails;
        var units = null;
        var singleUnit = true;
        const originalRentPaymentOption = this.state.leaseData.rent_payment_option;
        const originalTenantPayRentId = this.state.leaseData.tenant_pay_rent_id;
        const leaseStatus = this.checkLeaseStatus(moment(this.state.leaseData.contract_expiration_date));
        const lastUpdate = Math.ceil((moment() - moment(leaseData.last_updated)) * 0.001 / 86400); //Calculate # of days
        const signature = this.state.signature;
        const completed_signature = this.state.completed_signature;
        const prorate_amount = this.state.leaseData.prorate_amount;
        const sales_percentage = this.state.leaseData.sales_percentage;
        const sales_min = this.state.leaseData.sales_min;
        const sales_max = this.state.leaseData.sales_max;
        const increase_rent_amount = this.state.leaseData.increase_rent_amount;
        const increase_rent_length = this.state.leaseData.increase_rent_length;
        const deposit_amount = this.state.leaseData.deposit_amount;
        const pet_deposit_amount = this.state.leaseData.pet_deposit_amount;

        var proRateClicked = ""
        var chargePercentageClicked = ""
        var increaseRentClicked = ""
        var collectDepositClicked = ""
        var collectPetDepositClicked = ""
        var setPrepaidClicked = ""
        if (this.state.showProRate == true) {
            proRateClicked = "clicked"
        }
        if (this.state.showChargeSalePercentage == true) {
            chargePercentageClicked = "clicked"
        }
        if (this.state.showIncreaseRent == true) {
            increaseRentClicked = "clicked"
        }
        if (this.state.showCollectDeposit == true) {
            collectDepositClicked = "clicked"
        }
        if (this.state.showCollectPetDeposit == true) {
            collectPetDepositClicked = "clicked"
        }
        if (this.state.showPrepaidOption == true) {
            setPrepaidClicked = "clicked"
        }

        var alertLeaseStatus = false;
        if (leaseStatus.includes("months") == true) {
            alertLeaseStatus = false
        } else {
            alertLeaseStatus = true
        }

        var depositPaidText = "";
        var disableRequestDeposit = false;
        if (tenantArray != null && tenantArray.length != 0) {
            if (this.state.hasAllPaidDeposit == true) {
                depositPaidText = "Collected"
                disableRequestDeposit = true
            } else {
                depositPaidText = "Not Collected"
                disableRequestDeposit = false
            }
        } else {
            depositPaidText = "N/A"
            disableRequestDeposit = true
        }

        var leaseStatusBanner = "";
        if (leaseStatus == "Expired!") {
            leaseStatusBanner = "Expired"
        } else if (leaseStatus.includes("months") == true) {
            leaseStatusBanner = ""
        } else {
            leaseStatusBanner = "Expiring"
        }

        var vacantLease = true;
        if (tenantArray.length > 0) {
            vacantLease = false;
        }

        var leaseSigned = "N/A";
        var disableRequestSig = true;
        var requestSigButtonText = "Request E-Sig";
        var awaitingESig = false;
        if (tenantArray != null && tenantArray.length != 0) {
            if ((signature == null || signature.length == 0) && (completed_signature == null || completed_signature.length == 0)) {
                leaseSigned = "Not Requested";
                disableRequestSig = false;
                requestSigButtonText = "Request E-Sig";
                awaitingESig = false;
            } else if ((signature != null || signature.length > 0) && (completed_signature == null || completed_signature.length == 0)) {
                leaseSigned = "Requested - no tenants have signed";
                disableRequestSig = false;
                requestSigButtonText = "Re-request E-Sig";
                awaitingESig = true;
            } else if ((signature == null || signature.length == 0) && (completed_signature != null || completed_signature.length > 0)) {
                leaseSigned = "Signed";
                disableRequestSig = true;
                requestSigButtonText = "Request E-Sig";
                awaitingESig = false;
            } else if ((signature != null || signature.length > 0) && (completed_signature != null || completed_signature.length > 0)) {
                leaseSigned = "Requested - not all tenants have signed";
                disableRequestSig = false;
                requestSigButtonText = "Re-request E-Sig";
                awaitingESig = true;
            }
        }

        var disableRequestRenewal = true;
        if (tenantArray != null && tenantArray.length != 0) {
            disableRequestRenewal = false
        }

        const selectedRentPaymentOption = this.state.selected_rent_payment_option;
        const selectedTenantPayRentId = this.state.selected_tenant_pay_rent_id;
        var selectedTenantPayRentName = "";
        if (selectedTenantPayRentId != null) {
            tenantArray.map(function(item) {
                if (item.tenant.tenant_id == selectedTenantPayRentId) {
                    selectedTenantPayRentName = item.tenant_data.tenant_firstname + " " + item.tenant_data.tenant_lastname
                }
            })
        }

        var tenantsList = [];
        if (tenantArray != null && tenantArray.length != 0) {
            tenantArray.map(function(item) {
                var tenant_arr = []
                tenant_arr.push(item.tenant.tenant_id)
                tenant_arr.push(item.tenant_data.tenant_firstname + " " + item.tenant_data.tenant_lastname)
                tenantsList.push(tenant_arr)
            })
        }

        if (selectedProperty != null) {
            if (selectedProperty.units_tally != 0) {
                singleUnit = false;
                units = selectedProperty.units.map((unit, index) => (
                    unit.property_unit_id == selectedUnitId ? (
                        <div class="form-group" key={index}>
                            <label for="unitname">Unit Name</label>
                            <input type="text" class="form-control selectable-unit selected-unit property-unit" value={unit.unit_name} name="unitname" disabled onClick={self.selectedUnit.bind(self, unit.property_unit_id)}/>
                        </div>
                    ) : (
                        <div class="form-group" key={index}>
                            <label for="unitname">Unit Name</label>
                            <input type="text" class="form-control selectable-unit property-unit" value={unit.unit_name} name="unitname" disabled onClick={self.selectedUnit.bind(self, unit.property_unit_id)}/>
                        </div>
                    )
                ));
            }
        }

        var contract_expiration_date = moment(leaseData.contract_expiration_date).format('MMMM Do YYYY');
        if(contract_expiration_date == 'Invalid date') {
            contract_expiration_date = '';
        }
        var effective_date = moment(leaseData.effective_date).format('MMMM Do YYYY');
        if(effective_date == 'Invalid date') {
            effective_date = '';
        }
        var created_date = moment(leaseData.created_date).format('MMMM Do YYYY');
        if(created_date == 'Invalid date') {
            created_date = '';
        }
        var prepaid_end_date = moment(leaseData.prepaid_end_date).format('MMMM Do YYYY');
        if(prepaid_end_date == 'Invalid date') {
            prepaid_end_date = '';
        }

        var tenantsNameStr = "N/A";
        if (tenantArray != null && tenantArray.length != 0) {
            tenantsNameStr = []
            tenantsList.map(function(tenant){
                if (tenantsNameStr.length == 0) {
                    tenantsNameStr.push(<NavLink to={"/tenant/" + tenant[0]}>{tenant[1]}</NavLink>)
                } else {
                    tenantsNameStr.push(", ")
                    tenantsNameStr.push(<NavLink to={"/tenant/" + tenant[0]}>{tenant[1]}</NavLink>)
                }
            })
        }

        //Move In Variables
        const tenantId = this.state.tenantsMoveInData.tenant_id;
        const securityDeposit = this.state.tenantsMoveInData.securityDeposit;
        const petDeposit = this.state.tenantsMoveInData.petDeposit;
        const rentAmount = this.state.tenantsMoveInData.rentAmount;
        const effectiveDate = this.state.tenantsMoveInData.effectiveDate;
        const termLengthMoveIn = this.state.tenantsMoveInData.termLength;
        const expirationDate = this.state.tenantsMoveInData.expirationDate;
        const rentDueDay = this.state.tenantsMoveInData.rentDueDay;
        const requestElectronic = this.state.tenantsMoveInData.requestElectronic;
        const tenantsIdListMoveIn = this.state.tenantsMoveInData.tenantsIdList;
        const tenantsListMoveIn = this.state.tenantsMoveInData.tenantsList;
        const totalSelectedTenants = this.state.tenantsMoveInData.totalSelectedTenants;
        const rentPaymentOption = this.state.tenantsMoveInData.rentPaymentOption;
        const tenantPayRentId = this.state.tenantsMoveInData.tenantPayRentId;
        const collectSecurityDeposit = this.state.tenantsMoveInData.collectSecurityDeposit;
        const collectPetDeposit = this.state.tenantsMoveInData.collectPetDeposit;
        const collectRentNow = this.state.tenantsMoveInData.collectRentNow;
        const collectRentDate = this.state.tenantsMoveInData.collectRentDate;
        const moveInStartDate = this.state.tenantsMoveInData.startDate;
        const moveInEndDate = this.state.tenantsMoveInData.endDate;
        var disableESigToggle = false;
        if (agreement == null) {
            disableESigToggle = true;
        }

        //Move Out Variables
        const tenantsIdListMoveOut = this.state.tenantsMoveOutData.tenantsIdList;
        const tenantsListMoveOut = this.state.tenantsMoveOutData.tenantsList;
        var tenantsSelectListMoveOut = [];
        if (tenantArray != null && tenantArray.length != 0) {
            tenantArray.map(function(item) {
                var tenant_arr = []
                tenant_arr.push(item.tenant.tenant_id)
                tenant_arr.push(item.tenant_data.tenant_firstname + " " + item.tenant_data.tenant_lastname)
                tenantsSelectListMoveOut.push(tenant_arr)
            })
        }

        if (newLease) {
            return (
                <div>
                <div class="row blue-bottom-margin">
                    <div class="row">
                        <div class="sub-page-header-row col-md-11">
                            <div class="row">
                                <span class="sub-page-header-title">Add a Lease</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8 col-sm-12 col-xs-12">
                        <div class="col-md-12 card">
                            <div class="header">
                                <h4 class="title">Lease Information</h4>
                                <p class="category"></p>
                            </div>
                            <div class="content">
                                <form>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="row">
                                                <div class="col-md-5 col-sm-6 col-xs-12">
                                                    <div class="form-group">
                                                        <label for="assignee">Name*</label>
                                                        <input type="text" value={leaseName} class="form-control tenant-info" name="title" placeholder="Lease 401..." id="title" onChange={this.handleTitleChange.bind(this)}/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="header">
                                                <h4 class="title">Lease Terms</h4>
                                                <p class="category"></p>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12 col-sm-12 col-xs-12" style={{textAlign: "center", paddingBottom: 0}}>
                                                    <span class="tenant-charge-sentence">
                                                        Tenant will pay base rent of
                                                    </span>
                                                    <span class="tenant-charge-sentence">
                                                        <div class="form-group has-feedback">
                                                            <input type="text" class="form-control input-group-dollar-addon text-underline" value={leaseData.contract_amount} onChange={this.handleAmountChange.bind(this)} placeholder="Price" style={{paddingLeft: "35px", textAlign: 'left'}}/>
                                                            <i class="form-control-feedback fa fa-dollar" style={{left:"3px"}}></i>
                                                        </div>
                                                    </span>
                                                    <span class="tenant-charge-sentence">
                                                        each
                                                    </span>
                                                    <span class="tenant-charge-sentence">
                                                        <select class="form-control text-underline" defaultValue="month">
                                                            <option key="month" value="month">month</option>
                                                        </select>
                                                    </span>
                                                    <span class="tenant-charge-sentence">
                                                        for
                                                    </span>
                                                    <span class="tenant-charge-sentence">
                                                        <select class="form-control text-underline" defaultValue="1" value={termLength} onChange={this.onTermLengthChange.bind(this)}>
                                                            { termOptions }
                                                        </select>
                                                    </span>
                                                    <span class="tenant-charge-sentence">
                                                        month{termLength > 1 && "s"}.
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12 col-sm-12 col-xs-12" style={{textAlign: "center"}}>
                                                    <span class="tenant-charge-sentence">
                                                        Rent will be due on the
                                                    </span>
                                                    <span class="tenant-charge-sentence">
                                                        <select class="form-control text-underline" defaultValue="1" value={leaseData.rent_due_day} onChange={this.handleRentDueDateChange.bind(this)}>
                                                            { daysOptions }
                                                        </select>
                                                    </span>
                                                    <span class="tenant-charge-sentence">
                                                        of each month
                                                    </span>
                                                    {this.state.showCollectDeposit == true && (
                                                    <div>
                                                        <span class="tenant-charge-sentence">
                                                            <b>and</b>
                                                        </span>
                                                        <span class="tenant-charge-sentence">
                                                            tenant will pay a
                                                        </span>
                                                        <span class="tenant-charge-sentence">
                                                            <div class="form-group has-feedback">
                                                                <input type="text" value={deposit_amount} style={{paddingLeft: "35px", textAlign: 'left'}} onChange={this.handleDepositAmountChange.bind(this)} class="form-control input-group-dollar-addon text-underline" placeholder="Price"/>
                                                                <i class="form-control-feedback fa fa-dollar" style={{left:"3px"}}></i>
                                                            </div>
                                                        </span>
                                                        <span class="tenant-charge-sentence">
                                                            security deposit
                                                        </span>
                                                    </div>
                                                    )}
                                                    {this.state.showCollectPetDeposit == true && (
                                                    <div>
                                                        <span class="tenant-charge-sentence">
                                                            <b>and</b>
                                                        </span>
                                                        <span class="tenant-charge-sentence">
                                                            tenant will pay a
                                                        </span>
                                                        <span class="tenant-charge-sentence">
                                                            <div class="form-group has-feedback">
                                                                <input type="text" value={pet_deposit_amount} style={{paddingLeft: "35px", textAlign: 'left'}} onChange={this.handlePetDepositAmountChange.bind(this)} class="form-control input-group-dollar-addon text-underline" placeholder="Price"/>
                                                                <i class="form-control-feedback fa fa-dollar" style={{left:"3px"}}></i>
                                                            </div>
                                                        </span>
                                                        <span class="tenant-charge-sentence">
                                                            pet deposit
                                                        </span>
                                                    </div>
                                                    )}
                                                    {this.state.showProRate == true && (
                                                    <div>
                                                        <span class="tenant-charge-sentence">
                                                            <b>and</b>
                                                        </span>
                                                        <span class="tenant-charge-sentence">
                                                            prorate first month of rent by
                                                        </span>
                                                        <span class="tenant-charge-sentence">
                                                            <div class="form-group has-feedback">
                                                                <input type="text" value={prorate_amount} style={{paddingLeft: "35px", textAlign: 'left'}} onChange={this.handleProrateAmountChange.bind(this)} class="form-control input-group-dollar-addon text-underline" placeholder="Price"/>
                                                                <i class="form-control-feedback fa fa-dollar" style={{left:"3px"}}></i>
                                                            </div>
                                                        </span>
                                                    </div>
                                                    )}
                                                    {this.state.showChargeSalePercentage == true && (
                                                    <div>
                                                        <span class="tenant-charge-sentence">
                                                            <b>and</b>
                                                        </span>
                                                        <span class="tenant-charge-sentence">
                                                            charge tenant
                                                        </span>
                                                        <span class="tenant-charge-sentence">
                                                            <div class="form-group has-feedback">
                                                                <input type="text" style={{paddingLeft: "35px", textAlign: 'left'}} value={sales_percentage} onChange={this.handleSalesPercentageChange.bind(this)} class="form-control text-underline" placeholder="10"/>
                                                                <i class="form-control-feedback fa fa-percent" style={{left:"3px"}}></i>
                                                            </div>
                                                        </span>
                                                        <span class="tenant-charge-sentence">
                                                            of sales reported with a minimum charge of
                                                        </span>
                                                        <span class="tenant-charge-sentence">
                                                            <div class="form-group has-feedback">
                                                                <input type="text" style={{paddingLeft: "35px", textAlign: 'left'}} value={sales_min} onChange={this.handleSalesMinChange.bind(this)} class="form-control input-group-dollar-addon text-underline" placeholder="235"/>
                                                                <i class="form-control-feedback fa fa-dollar" style={{left:"3px"}}></i>
                                                            </div>
                                                        </span>
                                                        <span class="tenant-charge-sentence">
                                                            and a maximum charge of
                                                        </span>
                                                        <span class="tenant-charge-sentence">
                                                            <div class="form-group has-feedback">
                                                                <input type="text" style={{paddingLeft: "35px", textAlign: 'left'}} value={sales_max} onChange={this.handleSalesMaxChange.bind(this)} class="form-control input-group-dollar-addon text-underline" placeholder="5000"/>
                                                                <i class="form-control-feedback fa fa-dollar" style={{left:"3px"}}></i>
                                                            </div>
                                                        </span>
                                                    </div>
                                                    )}
                                                    {this.state.showIncreaseRent == true && (
                                                    <div>
                                                        <span class="tenant-charge-sentence">
                                                            <b>and</b>
                                                        </span>
                                                        <span class="tenant-charge-sentence">
                                                            increase rent by
                                                        </span>
                                                        <span class="tenant-charge-sentence">
                                                            <div class="form-group has-feedback">
                                                                <input type="text" style={{paddingLeft: "35px", textAlign: 'left'}} value={increase_rent_amount} onChange={this.handleIncreaseRentAmountChange.bind(this)} class="form-control input-group-dollar-addon text-underline" placeholder="Price"/>
                                                                <i class="form-control-feedback fa fa-dollar" style={{left:"3px"}}></i>
                                                            </div>
                                                        </span>
                                                        <span class="tenant-charge-sentence">
                                                            after
                                                        </span>
                                                        <span class="tenant-charge-sentence">
                                                            <select class="form-control text-underline" defaultValue="1" value={increase_rent_length} onChange={this.handleIncreaseRentLengthChange.bind(this)}>
                                                                { termOptions }
                                                            </select>
                                                        </span>
                                                        <span class="tenant-charge-sentence">
                                                            month{increase_rent_length > 1 && "s"}
                                                        </span>
                                                    </div>
                                                    )}
                                                    {this.state.showPrepaidOption === true && (
                                                        <div>
                                                            <span class="tenant-charge-sentence">
                                                                <b>and</b>
                                                            </span>
                                                            <span class="tenant-charge-sentence">
                                                                tenant is prepaid up until
                                                            </span>
                                                            <span class="tenant-charge-sentence">
                                                                <div class="form-group">
                                                                    <input type="text" class="form-control text-underline" onChange={this.handlePrepaidEndDateChange.bind(this)} id="lease_term_prepaid" value={prepaid_end_date} placeholder="Prepaid End Date" />
                                                                </div>
                                                            </span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div class="header">
                                                <h4 class="title">Lease Rules</h4>
                                                <p class="category"></p>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12 col-sm-12 col-xs-12">Customize your lease using lease rules.</div>
                                                <div class="col-md-12 col-sm-12 col-xs-12">
                                                    <div class="col-md-4 col-sm-6 col-xs-12">
                                                        <p class={"lease-rule-button " + collectDepositClicked} onClick={this.onCollectSecurityDepositClick.bind(this)}>
                                                            Collect security deposit
                                                        </p>
                                                        <p class={"lease-rule-button " + collectPetDepositClicked} onClick={this.onCollectPetDepositClick.bind(this)}>
                                                            Collect pet deposit
                                                        </p>
                                                        <p class={"lease-rule-button " + proRateClicked} onClick={this.onProRateClick.bind(this)}>
                                                            Prorate first month of rent
                                                        </p>
                                                        <p class={"lease-rule-button " + chargePercentageClicked} onClick={this.onChargePercentageClick.bind(this)}>
                                                            Collect % of sales
                                                        </p>
                                                    </div>
                                                    <div class="col-md-4 col-sm-6 col-xs-12">
                                                        <p class={"lease-rule-button " + increaseRentClicked} onClick={this.onIncreaseRentClick.bind(this)}>
                                                            Rent increase after term
                                                        </p>
                                                        <p class={"lease-rule-button " + setPrepaidClicked} onClick={this.onSetPrepaidOptionClick.bind(this)}>
                                                            Set prepaid option
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-12 col-xs-12">
                        <div class="col-md-12 card">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="header">
                                        <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="icon-document-plus"></i></span> Lease Agreement</h4>
                                        <p class="category">Upload relavant tenant documents</p>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="content">
                                                {agreement}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="content">
                                            { this.state.dropZoneSetup !== undefined && (
                                                <DropzoneComponent config={this.state.dropZoneConfig}
                                                    eventHandlers={this.state.dropZoneEventHandlers}
                                                    djsConfig={this.state.dropZoneJSConfig} />
                                            )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-12 col-xs-12">
                        <div class="col-md-12 card">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="header">
                                        <h4 class="title"><i class="pe-7s-cash"></i> Fees</h4>
                                        <p class="category">Any fees added will automatically be included on each rent payment.</p>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="content">
                                                { feeDetails != null && (
                                                    <span>
                                                    <p>Amount: <b>${feeDetails.fee_amount / 100}</b></p>
                                                    <p>Percentage: <b>{feeDetails.fee_percentage}%</b></p>
                                                    </span>
                                                )}
                                                <FeesSelect columnSize={0} sortID={fee} title="" onChange={this.handleFeeChange.bind(this)}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8 col-sm-12 col-xs-12">
                        <div class="col-md-12 card">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="header">
                                        <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="icon-house-outline"></i></span> Property</h4>
                                        <p class="category"></p>
                                    </div>
                                    <div class="col-md-8 col-md-offset-2">
                                        <div class="form-group">
                                            <label>Property</label>
                                            <PropertiesSelect columnSize={0} sortID={property_id} title="" onChange={this.handlePropertyChange.bind(this)} />
                                        </div>
                                    </div>
                                    { selectedProperty != null && (
                                    <div class="row">
                                        <div class="col-md-9 col-md-offset-1">
                                            { selectedProperty.photo == null ? (
                                            <div class="property-photo">
                                                <p>No cover image.</p>
                                            </div>
                                            ) : (
                                            <div class="property-photo">
                                                <img src={selectedProperty.photo.url} width="100%" />
                                            </div>
                                            )}
                                            <div class="header">
                                                <h4 class="title">{selectedProperty.details.property_name}</h4>
                                                <p class="category">{selectedProperty.details.property_address}<br/>{selectedProperty.details.property_city} {selectedProperty.details.property_state}, {selectedProperty.details.property_zip}</p>
                                            </div>
                                        </div>
                                    </div>
                                    )}
                                    { singleUnit == false && (
                                    <div class="row">
                                        <div class="col-md-9 col-md-offset-1">
                                            <p>Select a unit for this lease to attach to, otherwise we will assign it to this property.</p>
                                            {units}
                                        </div>
                                    </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row blue-bottom">
                    <div class="blue-bottom-center-align">
                        <div class="col-md-12">
                            <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off" onClick={this.handleSaveLeaseDataOnboarding.bind(this)}>
                            Create Lease
                            </button>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                </div>
                </div>
            )
        } else {
            return (
                <div>
                <div class="row blue-bottom-margin">
                    <div class="row">
                        <div class="sub-page-header-row col-md-11">
                            <div class="row">
                                <span class="sub-page-header-title">{leaseName}</span>
                            </div>
                            {lastUpdate > 1 ? (
                            <div class="row">
                                <span class="sub-page-header-sub-title">Updated {lastUpdate} days ago</span>
                            </div>
                            ) : (
                            <div>
                                {lastUpdate == 1 ? (
                                <div class="row">
                                    <span class="sub-page-header-sub-title">Updated 1 day ago</span>
                                </div>
                                ) : (
                                <div class="row">
                                    <span class="sub-page-header-sub-title">Updated less than 1 day ago</span>
                                </div>
                                )}
                            </div>
                            )}
                            {leaseStatusBanner != "" && (
                            <div class="row">
                                {leaseStatusBanner == "Expiring" ? (
                                <span class="orange-sub-page-header-banner" style={{marginTop: "-133px"}}>
                                    {leaseStatusBanner}
                                </span>
                                ) : (
                                <span class="red-sub-page-header-banner" style={{marginTop: "-133px"}}>
                                    {leaseStatusBanner}
                                </span>
                                )}
                            </div>
                            )}
                            {awaitingESig == true && (
                            <div class="row">
                                <span class="green-sub-page-header-banner">
                                    PENDING E-SIG
                                </span>
                            </div>
                            )}
                            {vacantLease == true && (
                            <div class="row">
                                <span class="red-sub-page-header-banner">
                                    VACANT
                                </span>
                            </div>
                            )}
                            {leaseData.created_date && (
                            <div>
                                <div class="row">
                                    <span class="sub-page-header-submit-title">
                                        Date Created
                                    </span>
                                </div>
                                <div class="row">
                                    <span class="sub-page-header-submit-date">
                                        {moment.utc(leaseData.created_date).local().format('DD MMM YYYY, h:mm A')}
                                    </span>
                                </div>
                            </div>
                            )}
                             <TabGroup noteActiveTab={(index) => {
                                 index == 2 ? (
                                     this.setState({
                                         invoicingActive: true,
                                     })
                                 ) : (
                                     this.state.invoicingActive && this.setState({invoicingActive: false})
                                 )
                                 index === 0 && jQuery('#effective_date').datepicker({
                                     changeMonth: true,
                                     changeYear: true,
                                     dateFormat: 'yy-mm-dd',
                                     onSelect: function(e) {
                                         self.handleEffectiveDateChange(e);
                                     }
                                 })
                             }}>
                                <Tab title="overview">
                                    <div>
                                        <div class="col-md-8 col-sm-12 col-xs-12">
                                            <div class="col-md-12 card">
                                                <div class="header">
                                                    <h4 class="title">Lease Information</h4>
                                                    <p class="category"></p>
                                                </div>
                                                <div class="content">
                                                    <form>
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <div class="row">
                                                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                                                        <div class="form-group">
                                                                            <label for="assignee">Name*</label>
                                                                            <input type="text" value={leaseName} class="form-control tenant-info" name="title" placeholder="Lease 401..." id="title" onChange={this.handleTitleChange.bind(this)} />
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-5 col-md-offset-1 col-sm-6 col-xs-12">
                                                                        <div class="form-group">
                                                                            <label for="effective_date">Move In Date</label>
                                                                            <input type="text" value={effective_date} class="form-control tenant-info" name="effective_date" placeholder="Select an effective date" id="effective_date" onChange={this.handleEffectiveDateChange.bind(this)} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="header">
                                                                    <h4 class="title">Lease Terms</h4>
                                                                    <p class="category"></p>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-md-12 col-sm-12 col-xs-12" style={{ textAlign: "center", paddingBottom: 0 }}>
                                                                        <span class="tenant-charge-sentence">
                                                                            Tenant will pay base rent of
                                                                        </span>
                                                                        <span class="tenant-charge-sentence">
                                                                            <div class="form-group has-feedback">
                                                                                <input type="text" class="form-control input-group-dollar-addon text-underline" value={leaseData.contract_amount} onChange={this.handleAmountChange.bind(this)} placeholder="Price" style={{ paddingLeft: "35px", textAlign: 'left' }} />
                                                                                <i class="form-control-feedback fa fa-dollar" style={{ left: "3px" }}></i>
                                                                            </div>
                                                                        </span>
                                                                        <span class="tenant-charge-sentence">
                                                                            each
                                                                        </span>
                                                                        <span class="tenant-charge-sentence">
                                                                            <select class="form-control text-underline" defaultValue="month">
                                                                                <option key="month" value="month">month</option>
                                                                            </select>
                                                                        </span>
                                                                        <span class="tenant-charge-sentence">
                                                                            for
                                                                        </span>
                                                                        <span class="tenant-charge-sentence">
                                                                            <select class="form-control text-underline" defaultValue="1" value={termLength} onChange={this.onTermLengthChange.bind(this)}>
                                                                                {termOptions}
                                                                            </select>
                                                                        </span>
                                                                        <span class="tenant-charge-sentence">
                                                                            month{termLength > 1 && "s"}.
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-md-12 col-sm-12 col-xs-12" style={{ textAlign: "center" }}>
                                                                        <span class="tenant-charge-sentence">
                                                                            Rent will be due on the
                                                                        </span>
                                                                        <span class="tenant-charge-sentence">
                                                                            <select class="form-control text-underline" defaultValue="1" value={leaseData.rent_due_day} onChange={this.handleRentDueDateChange.bind(this)}>
                                                                                {daysOptions}
                                                                            </select>
                                                                        </span>
                                                                        <span class="tenant-charge-sentence">
                                                                            of each month
                                                                        </span>
                                                                        {this.state.showCollectDeposit == true && (
                                                                            <div>
                                                                                <span class="tenant-charge-sentence">
                                                                                    <b>and</b>
                                                                                </span>
                                                                                <span class="tenant-charge-sentence">
                                                                                    tenant will pay a
                                                                                </span>
                                                                                <span class="tenant-charge-sentence">
                                                                                    <div class="form-group has-feedback">
                                                                                        <input type="text" value={deposit_amount} style={{ paddingLeft: "35px", textAlign: 'left' }} onChange={this.handleDepositAmountChange.bind(this)} class="form-control input-group-dollar-addon text-underline" placeholder="Price" />
                                                                                        <i class="form-control-feedback fa fa-dollar" style={{ left: "3px" }}></i>
                                                                                    </div>
                                                                                </span>
                                                                                <span class="tenant-charge-sentence">
                                                                                    security deposit
                                                                                </span>
                                                                            </div>
                                                                        )}
                                                                        {this.state.showCollectPetDeposit == true && (
                                                                            <div>
                                                                                <span class="tenant-charge-sentence">
                                                                                    <b>and</b>
                                                                                </span>
                                                                                <span class="tenant-charge-sentence">
                                                                                    tenant will pay a
                                                                                </span>
                                                                                <span class="tenant-charge-sentence">
                                                                                    <div class="form-group has-feedback">
                                                                                        <input type="text" value={pet_deposit_amount} style={{ paddingLeft: "35px", textAlign: 'left' }} onChange={this.handlePetDepositAmountChange.bind(this)} class="form-control input-group-dollar-addon text-underline" placeholder="Price" />
                                                                                        <i class="form-control-feedback fa fa-dollar" style={{ left: "3px" }}></i>
                                                                                    </div>
                                                                                </span>
                                                                                <span class="tenant-charge-sentence">
                                                                                    pet deposit
                                                                                </span>
                                                                            </div>
                                                                        )}
                                                                        {this.state.showProRate == true && (
                                                                            <div>
                                                                                <span class="tenant-charge-sentence">
                                                                                    <b>and</b>
                                                                                </span>
                                                                                <span class="tenant-charge-sentence">
                                                                                    prorate first month of rent by
                                                                                </span>
                                                                                <span class="tenant-charge-sentence">
                                                                                    <div class="form-group has-feedback">
                                                                                        <input type="text" value={prorate_amount} style={{ paddingLeft: "35px", textAlign: 'left' }} onChange={this.handleProrateAmountChange.bind(this)} class="form-control input-group-dollar-addon text-underline" placeholder="Price" />
                                                                                        <i class="form-control-feedback fa fa-dollar" style={{ left: "3px" }}></i>
                                                                                    </div>
                                                                                </span>
                                                                            </div>
                                                                        )}
                                                                        {this.state.showChargeSalePercentage == true && (
                                                                            <div>
                                                                                <span class="tenant-charge-sentence">
                                                                                    <b>and</b>
                                                                                </span>
                                                                                <span class="tenant-charge-sentence">
                                                                                    charge tenant
                                                                                </span>
                                                                                <span class="tenant-charge-sentence">
                                                                                    <div class="form-group has-feedback">
                                                                                        <input type="text" style={{ paddingLeft: "35px", textAlign: 'left' }} value={sales_percentage} onChange={this.handleSalesPercentageChange.bind(this)} class="form-control text-underline" placeholder="10" />
                                                                                        <i class="form-control-feedback fa fa-percent" style={{ left: "3px" }}></i>
                                                                                    </div>
                                                                                </span>
                                                                                <span class="tenant-charge-sentence">
                                                                                    of sales reported with a minimum charge of
                                                                                </span>
                                                                                <span class="tenant-charge-sentence">
                                                                                    <div class="form-group has-feedback">
                                                                                        <input type="text" style={{ paddingLeft: "35px", textAlign: 'left' }} value={sales_min} onChange={this.handleSalesMinChange.bind(this)} class="form-control input-group-dollar-addon text-underline" placeholder="235" />
                                                                                        <i class="form-control-feedback fa fa-dollar" style={{ left: "3px" }}></i>
                                                                                    </div>
                                                                                </span>
                                                                                <span class="tenant-charge-sentence">
                                                                                    and a maximum charge of
                                                                                </span>
                                                                                <span class="tenant-charge-sentence">
                                                                                    <div class="form-group has-feedback">
                                                                                        <input type="text" style={{ paddingLeft: "35px", textAlign: 'left' }} value={sales_max} onChange={this.handleSalesMaxChange.bind(this)} class="form-control input-group-dollar-addon text-underline" placeholder="5000" />
                                                                                        <i class="form-control-feedback fa fa-dollar" style={{ left: "3px" }}></i>
                                                                                    </div>
                                                                                </span>
                                                                            </div>
                                                                        )}
                                                                        {this.state.showIncreaseRent == true && (
                                                                            <div>
                                                                                <span class="tenant-charge-sentence">
                                                                                    <b>and</b>
                                                                                </span>
                                                                                <span class="tenant-charge-sentence">
                                                                                    increase rent by
                                                                                </span>
                                                                                <span class="tenant-charge-sentence">
                                                                                    <div class="form-group has-feedback">
                                                                                        <input type="text" style={{ paddingLeft: "35px", textAlign: 'left' }} value={increase_rent_amount} onChange={this.handleIncreaseRentAmountChange.bind(this)} class="form-control input-group-dollar-addon text-underline" placeholder="Price" />
                                                                                        <i class="form-control-feedback fa fa-dollar" style={{ left: "3px" }}></i>
                                                                                    </div>
                                                                                </span>
                                                                                <span class="tenant-charge-sentence">
                                                                                    after
                                                                                </span>
                                                                                <span class="tenant-charge-sentence">
                                                                                    <select class="form-control text-underline" defaultValue="1" value={increase_rent_length} onChange={this.handleIncreaseRentLengthChange.bind(this)}>
                                                                                        {termOptions}
                                                                                    </select>
                                                                                </span>
                                                                                <span class="tenant-charge-sentence">
                                                                                    month{increase_rent_length > 1 && "s"}
                                                                                </span>
                                                                            </div>
                                                                        )}
                                                                        {this.state.showPrepaidOption === true && (
                                                                            <div>
                                                                                <span class="tenant-charge-sentence">
                                                                                    <b>and</b>
                                                                                </span>
                                                                                <span class="tenant-charge-sentence">
                                                                                    tenant is prepaid up until
                                                                                </span>
                                                                                <span class="tenant-charge-sentence">
                                                                                    <div class="form-group">
                                                                                        <input type="text" class="form-control text-underline" onChange={this.handlePrepaidEndDateChange.bind(this)} id="lease_term_prepaid" value={prepaid_end_date} placeholder="Prepaid End Date" />
                                                                                    </div>
                                                                                </span>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div class="header">
                                                                    <h4 class="title">Lease Rules</h4>
                                                                    <p class="category"></p>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-md-12 col-sm-12 col-xs-12">Customize your lease using lease rules.</div>
                                                                    <div class="col-md-12 col-sm-12 col-xs-12">
                                                                        <div class="col-md-4 col-sm-6 col-xs-12">
                                                                            <p class={"lease-rule-button " + collectDepositClicked} onClick={this.onCollectSecurityDepositClick.bind(this)}>
                                                                                Collect security deposit
                                                                            </p>
                                                                            <p class={"lease-rule-button " + collectPetDepositClicked} onClick={this.onCollectPetDepositClick.bind(this)}>
                                                                                Collect pet deposit
                                                                            </p>
                                                                            <p class={"lease-rule-button " + proRateClicked} onClick={this.onProRateClick.bind(this)}>
                                                                                Prorate first month of rent
                                                                            </p>
                                                                            <p class={"lease-rule-button " + chargePercentageClicked} onClick={this.onChargePercentageClick.bind(this)}>
                                                                                Collect % of sales
                                                                            </p>
                                                                        </div>
                                                                        <div class="col-md-4 col-sm-6 col-xs-12">
                                                                            <p class={"lease-rule-button " + increaseRentClicked} onClick={this.onIncreaseRentClick.bind(this)}>
                                                                                Rent increase after term
                                                                            </p>
                                                                            <p class={"lease-rule-button " + setPrepaidClicked} onClick={this.onSetPrepaidOptionClick.bind(this)}>
                                                                                Set prepaid option
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                            <div class="col-md-12 card">
                                                <div class="card">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <div class="header">
                                                                <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="icon-person-group"></i></span> Tenants</h4>
                                                                <p class="category"></p>
                                                            </div>
                                                            <div class="content">
                                                                <form>
                                                                    <div class="col-md-12">
                                                                        <div class="row">
                                                                            <div class="col-md-5 col-sm-6 col-xs-12">
                                                                                <div class="form-group">
                                                                                    <label for="payment_option">Payment option</label>
                                                                                    {tenantArray != null && tenantArray.length > 0 && originalRentPaymentOption != null ? (
                                                                                        <select class="form-control" value={selectedRentPaymentOption} onChange={this.onRentPaymentOptionChange.bind(this)}>
                                                                                            <option key="0" value="Default">Select a rent payment option</option>
                                                                                            <option key="1" value="single">Single Payment</option>
                                                                                            {tenantArray.length > 1 && (
                                                                                                <option key="2" value="split">Split Rent</option>
                                                                                            )}
                                                                                        </select>
                                                                                    ) : (
                                                                                        <input type="text" class="form-control" placeholder="N/A" readOnly />
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                                                                <div class="form-group">
                                                                                    <label for="responsible_tenant">Tenant responsible for the rent</label>
                                                                                    {tenantArray != null && tenantArray.length != 0 && originalTenantPayRentId != null ? (
                                                                                        <select id="tenant-rent-responsible" class="form-control" value={selectedTenantPayRentId} onChange={this.onResponsibleTenantChange.bind(this)}>
                                                                                            <option key="0" value="Default">Select a tenant responsible for the rent</option>
                                                                                            {(tenantArray != null && tenantArray.length != 0) && (
                                                                                                tenantsList.map(function (tenant) {
                                                                                                    return (
                                                                                                        <option key={tenant[0]} value={tenant[0]}>{tenant[1]}</option>
                                                                                                    )
                                                                                                })
                                                                                            )}
                                                                                        </select>
                                                                                    ) : (
                                                                                        <input type="text" class="form-control" placeholder="N/A" readOnly />
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="row">
                                                                            <div class="col-md-4">
                                                                                <div class="form-group">
                                                                                    <label for="assignee">Tenant(s) moved in</label>
                                                                                    <ul class="tenant-list">
                                                                                        {tenantArray != null && tenantArray.length != 0 ? (
                                                                                            tenantsList.map(function (tenant) {
                                                                                                return (
                                                                                                    <li key={tenant[0]}>
                                                                                                        {tenant[1]}
                                                                                                    </li>
                                                                                                )
                                                                                            })
                                                                                        ) : (
                                                                                            <small>No tenants currently moved in.</small>
                                                                                        )}
                                                                                    </ul>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-2">
                                                                                <div class="form-group">
                                                                                    <label for="notify_tenant">Notify tenant(s) about the updates?</label>
                                                                                    <br />
                                                                                    {tenantArray != null && tenantArray.length != 0 ? (
                                                                                        <input type="checkbox" class="toggle-switch" id="notify_tenant" defaultChecked={notifyTenant} data-toggle="toggle" />
                                                                                    ) : (
                                                                                        <small>No current tenants to notify</small>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-12 card">
                                                <div class="card">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <div class="header">
                                                                <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="icon-house-outline"></i></span> Property</h4>
                                                                <p class="category"></p>
                                                            </div>
                                                            <div class="col-md-8 col-md-offset-2">
                                                                <div class="form-group">
                                                                    <PropertiesSelect columnSize={0} sortID={property_id} title="" onChange={this.handlePropertyChange.bind(this)} />
                                                                </div>
                                                            </div>
                                                            {selectedProperty != null && (
                                                                <div class="row">
                                                                    <div class="col-md-9 col-md-offset-1">
                                                                        {selectedProperty.photo == null ? (
                                                                            <div class="property-photo">
                                                                                <p>No cover image.</p>
                                                                            </div>
                                                                        ) : (
                                                                            <div class="property-photo">
                                                                                <img src={selectedProperty.photo.url} width="100%" />
                                                                            </div>
                                                                        )}
                                                                        <div class="header">
                                                                            <h4 class="title">{selectedProperty.details.property_name}</h4>
                                                                            <p class="category">{selectedProperty.details.property_address}<br />{selectedProperty.details.property_city} {selectedProperty.details.property_state}, {selectedProperty.details.property_zip}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {singleUnit == false && (
                                                                <div class="row">
                                                                    <div class="col-md-9 col-md-offset-1">
                                                                        <p>Select a unit for this lease to attach to, otherwise we will assign it to this property.</p>
                                                                        {units}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-sm-12 col-xs-12">
                                            <ActionCenterCard>
                                                {tenantArray != null && tenantArray.length != 0 ? (
                                                    <ActionCenterEntry
                                                        title="Tenant"
                                                        description={tenantsNameStr}
                                                        buttonText={"Move Out"}
                                                        buttonCallback={this.handleOpenMoveOutModal.bind(this)}
                                                        modal={
                                                            <Modal
                                                                isOpen={this.state.showMoveOutModal}
                                                                onRequestClose={this.handleCloseMoveOutModal.bind(this, false)}
                                                                style={modalStyles.getModalStyles()}
                                                                ariaHideApp={false}
                                                            >
                                                                <div class="row">
                                                                    <div class="modal-exit-icon pull-right" onClick={this.handleCloseMoveOutModal.bind(this, false)}></div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="modal-header">Move Out Tenants</div>
                                                                </div>
                                                                <form>
                                                                    <div class="row">
                                                                        <div class="col-md-12">
                                                                            <div class="row">
                                                                                <div class="col-md-8">
                                                                                    <div class="form-group">
                                                                                        <label for="assignee">Who do you want to move out?</label>
                                                                                        <div class="clearfix"></div>
                                                                                        <select class="form-control" onChange={this.sortTenantSelectMoveOut.bind(this)}>
                                                                                            <option key="0" value="Default">Select a tenant to move out</option>
                                                                                            {(tenantArray != null && tenantArray.length != 0) && (
                                                                                                tenantsSelectListMoveOut.map(function (tenant) {
                                                                                                    return (
                                                                                                        <option key={tenant[0]} value={tenant[0]}>{tenant[1]}</option>
                                                                                                    )
                                                                                                })
                                                                                            )}
                                                                                        </select>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="row">
                                                                                <div class="col-md-12">
                                                                                    <div class="form-group">
                                                                                        <label>Current selected tenant(s):</label>
                                                                                        {tenantsIdListMoveOut.length > 0 ? (
                                                                                            <div>
                                                                                                {tenantsListMoveOut.map((item, i) => (
                                                                                                    <div class="row" key={i}>
                                                                                                        <div class="col-md-6 col-sm-6 col-xs-6">{item[1]}</div>
                                                                                                        <div class="col-md-1 col-sm-1 col-xs-1" title={"Add " + item[1] + " back to the lease?"} onClick={this.handleRemoveTenantMoveOut.bind(this, item[0], item[1])}><i class="fa fa-close removeTenantIcon" /></div>
                                                                                                    </div>
                                                                                                ))}
                                                                                            </div>
                                                                                        ) : (
                                                                                            <div>
                                                                                                <div class="row">
                                                                                                    <div class="col-md-12">None</div>
                                                                                                </div>
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            {(tenantsIdListMoveOut.length == 0 && this.state.didAddTenant == true) && (
                                                                                <div class="row">
                                                                                    <div class="col-md-12">
                                                                                        <div>*All tenants associated with this lease will be moved out! No one will be paying this lease's rent!</div>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                            {tenantsIdListMoveOut.length > 0 && (
                                                                                <div class="row">
                                                                                    {tenantArray.length - tenantsIdListMoveOut.length > 0 && (
                                                                                        <div class="col-md-12">
                                                                                            <div class="row">
                                                                                                <div class="col-md-6 col-sm-6 col-xs-12">
                                                                                                    <div class="form-group">
                                                                                                        <label for="payment_option">Payment option</label>
                                                                                                        {tenantArray != null && tenantArray.length != 0 && originalRentPaymentOption != null ? (
                                                                                                            <select class="form-control" value={selectedRentPaymentOption} onChange={this.onRentPaymentOptionChange.bind(this)}>
                                                                                                                <option key="0" value="Default">Select a rent payment option</option>
                                                                                                                <option key="1" value="single">Single Payment</option>
                                                                                                                {(tenantArray.length - tenantsIdListMoveOut.length) > 1 && (
                                                                                                                    <option key="2" value="split">Split Rent</option>
                                                                                                                )}
                                                                                                            </select>
                                                                                                        ) : (
                                                                                                            <input type="text" class="form-control" placeholder="N/A" readOnly />
                                                                                                        )}
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div class="col-md-6 col-sm-6 col-xs-12">
                                                                                                    <div class="form-group">
                                                                                                        <label for="responsible_tenant">Tenant responsible for the rent</label>
                                                                                                        {tenantArray != null && tenantArray.length != 0 && originalTenantPayRentId != null ? (
                                                                                                            <select id="tenant-rent-responsible-moveout" class="form-control" value={selectedTenantPayRentId} onChange={this.onResponsibleTenantChange.bind(this)}>
                                                                                                                <option key="0" value="Default">Select a tenant responsible for the rent</option>
                                                                                                                {(tenantArray != null && tenantArray.length != 0) && (
                                                                                                                    tenantsList.map(function (tenant) {
                                                                                                                        return (
                                                                                                                            <option key={tenant[0]} value={tenant[0]}>{tenant[1]}</option>
                                                                                                                        )
                                                                                                                    })
                                                                                                                )}
                                                                                                            </select>
                                                                                                        ) : (
                                                                                                            <input type="text" class="form-control" placeholder="N/A" readOnly />
                                                                                                        )}
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                    {selectedRentPaymentOption == "single" ? (
                                                                                        <div class="row">
                                                                                            <div class="col-md-12">
                                                                                                {tenantArray.length - tenantsIdListMoveOut.length == 0 ? (
                                                                                                    <div>*All tenants associated with this lease will be moved out! No one will be paying this lease's rent!</div>
                                                                                                ) : (
                                                                                                    <div>
                                                                                                        {selectedTenantPayRentName != "" ? (
                                                                                                            <div>*The primary tenant who will be responsible for the whole rent is {selectedTenantPayRentName}.</div>
                                                                                                        ) : (
                                                                                                            <div>*There is no primary tenant who will be responsible for the whole rent. Please select one.</div>
                                                                                                        )}
                                                                                                    </div>
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <div class="row">
                                                                                            <div class="col-md-12">
                                                                                                {tenantArray.length - tenantsIdListMoveOut.length == 0 && (
                                                                                                    <div>*All tenants associated with this lease will be moved out! No one will be paying this lease's rent!</div>
                                                                                                )}
                                                                                                {tenantArray.length - tenantsIdListMoveOut.length == 1 && (
                                                                                                    <div>*The current rent is being split evenly among {tenantArray.length} tenants. By moving out the {tenantsIdListMoveOut.length}
                                                                                                        {tenantsIdListMoveOut.length == 1 ? " tenant " : " tenants "}
                                                                                                        above, we will update the invoice to charge the remaining tenant, who is then responsible for the whole rent,
                                                                                                        for a total of <b>${leaseData.contract_amount}</b>.</div>
                                                                                                )}
                                                                                                {tenantArray.length - tenantsIdListMoveOut.length > 1 && (
                                                                                                    <div>*The current rent is being split evenly among {tenantArray.length} tenants. By moving out the above tenant(s),
                                                                                                        we will update the invoice to charge the remaining tenants evenly for a total of <b>${leaseData.contract_amount}</b>.</div>
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-8 col-md-offset-4 col-sm-8 col-sm-offset-4 col-xs-8 col-xs-offset-3">
                                                                            <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.moveOut.bind(this, selectedTenantPayRentName)}>
                                                                                Move Out
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </form>
                                                            </Modal>
                                                        }
                                                    />
                                                ) : (
                                                    <ActionCenterEntry
                                                        title="Tenant"
                                                        description={tenantsNameStr}
                                                        buttonText={"Move In"}
                                                        buttonCallback={this.handleOpenMoveInModal.bind(this, false)}
                                                        modal={
                                                            <Modal
                                                                isOpen={this.state.showMoveInModal}
                                                                onRequestClose={this.handleCloseMoveInModal.bind(this, false)}
                                                                style={modalStyles.getModalStyles()}
                                                                ariaHideApp={false}
                                                                id={"move_in_modal"}
                                                            >
                                                                <div class="row">
                                                                    <div class="modal-exit-icon pull-right" onClick={this.handleCloseMoveInModal.bind(this, false)}></div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="modal-header">Move In Tenants</div>
                                                                </div>
                                                                <form>
                                                                    <div class="row">
                                                                        <div class="col-md-12">
                                                                            <div class="row">
                                                                                <div class="col-md-12">
                                                                                    <div class="form-group">
                                                                                        <label for="assignee">Who do you want to move in?</label>
                                                                                        <div class="clearfix"></div>
                                                                                        <TenantsSelect title="" columnSize={8} sortId={tenantId} onChange={this.sortTenantSelectMoveIn.bind(this)} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="row">
                                                                                <div class="col-md-8 col-md-offset-1">
                                                                                    <div class="form-group">
                                                                                        <label>Current selected tenant(s):</label>
                                                                                        {tenantsIdListMoveIn.length > 0 ? (
                                                                                            <div>
                                                                                                {tenantsListMoveIn.map((item, i) => (
                                                                                                    <div class="row" key={i}>
                                                                                                        <div class="col-md-6 col-sm-6 col-xs-6">{item[1]}</div>
                                                                                                        <div class="col-md-1 col-sm-1 col-xs-1" title={"Remove " + item[1] + " from the lease?"} onClick={this.handleRemoveTenantMoveIn.bind(this, item[0], item[1])}><i class="fa fa-close removeTenantIcon" /></div>
                                                                                                    </div>
                                                                                                ))}
                                                                                            </div>
                                                                                        ) : (
                                                                                            <div>
                                                                                                <div class="row">
                                                                                                    <div class="col-md-12">None</div>
                                                                                                </div>
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="row">
                                                                                <div class="col-md-6">
                                                                                    <div class="form-group">
                                                                                        <label for="assignee">When do the tenant(s) move in?</label>
                                                                                        <input type="text" class="form-control startdaterange" id="startdaterange" value={moveInStartDate} onChange={this.onMoveInDateRangePick.bind(this)} />
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-md-6">
                                                                                    <div class="form-group">
                                                                                        <label for="assignee">When do the tenant(s) move out?</label>
                                                                                        <input type="text" class="form-control enddaterange" id="enddaterange" value={moveInEndDate} onChange={this.onMoveOutDateRangePick.bind(this)} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            {totalSelectedTenants > 0 && (
                                                                                <div class="row">
                                                                                    <div class="col-md-6">
                                                                                        <div class="form-group">
                                                                                            <label for="assignee">How should the rent be paid?</label>
                                                                                            <select class="form-control" value={rentPaymentOption} onChange={this.onRentPaymentOptionMoveInChange.bind(this)}>
                                                                                                <option key="0" value="Default">Select a rent payment option</option>
                                                                                                <option key="1" value="single">Single Payment</option>
                                                                                                {totalSelectedTenants > 1 && (
                                                                                                    <option key="2" value="split">Split Rent</option>
                                                                                                )}
                                                                                            </select>
                                                                                        </div>
                                                                                    </div>
                                                                                    {(totalSelectedTenants > 0 && rentPaymentOption == "single") && (
                                                                                        <div class="col-md-6">
                                                                                            <div class="form-group">
                                                                                                <label for="assignee">Who is responsible for the rent?</label>
                                                                                                <select class="form-control" value={tenantPayRentId} onChange={this.onResponsibleTenantMoveInChange.bind(this)}>
                                                                                                    <option key="0" value="Default">Select a tenant responsible for the rent</option>
                                                                                                    {tenantsListMoveIn.map((item) => (
                                                                                                        <option key={item[0]} value={item[0]}>{item[1]}</option>
                                                                                                    ))}
                                                                                                </select>
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                            <div class="row">
                                                                                <div class="col-md-6">
                                                                                    <div class="form-group has-feedback">
                                                                                        <label for="assignee">How much is the rent?</label>
                                                                                        <input type="text" value={rentAmount} onChange={this.onRentChange.bind(this)} class="form-control input-group-dollar-addon" placeholder="How much will be paid a month?" />
                                                                                        <i class="form-control-feedback fa fa-dollar" style={{ left: "3px", paddingTop: "25px" }}></i>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-md-6">
                                                                                    <div class="form-group">
                                                                                        <label for="assignee">Collect the rent now?</label>
                                                                                        <select class="form-control" value={collectRentNow} onChange={this.onHandlingRentCollectionChange.bind(this)}>
                                                                                            <option key="0" value="Yes">Yes</option>
                                                                                            <option key="1" value="No">No</option>
                                                                                        </select>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="row">
                                                                                {collectRentNow == 'Yes' && (
                                                                                    <div class="col-md-6">
                                                                                        <div class="form-group">
                                                                                            <label>What date should you collect first rent?</label>
                                                                                            <input type="text" class="form-control" onChange={this.onCollectRentDateChange.bind(this)} id="collect_rent_date" value={collectRentDate} />
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                                <div class="col-md-6">
                                                                                    <div class="form-group">
                                                                                        <label>What day is the rent collected?</label>
                                                                                        <select class="form-control" value={rentDueDay} onChange={this.onRentDueDayChange.bind(this)}>
                                                                                            <option>Select a rent due day</option>
                                                                                            {daysOptions}
                                                                                        </select>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="row">
                                                                                <div class="col-md-6">
                                                                                    <div class="form-group has-feedback">
                                                                                        <label for="assignee">What is the security deposit amount?</label>
                                                                                        <input type="text" value={securityDeposit} onChange={this.onSecurityDepositChange.bind(this)} class="form-control input-group-dollar-addon" placeholder="How much is the security deposit?" />
                                                                                        <i class="form-control-feedback fa fa-dollar" style={{ left: "3px", paddingTop: "25px" }}></i>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-md-6">
                                                                                    <div class="form-group">
                                                                                        <label for="assignee">Collect the security deposit now?</label>
                                                                                        <select class="form-control" value={collectSecurityDeposit} onChange={this.onHandlingSecurityDepositChange.bind(this)}>
                                                                                            <option key="0" value="Yes">Yes</option>
                                                                                            <option key="1" value="No">No</option>
                                                                                        </select>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="row">
                                                                                <div class="col-md-6">
                                                                                    <div class="form-group has-feedback">
                                                                                        <label for="assignee">What is the pet deposit amount?</label>
                                                                                        <input type="text" value={petDeposit} onChange={this.onPetDepositChange.bind(this)} class="form-control input-group-dollar-addon" placeholder="How much is the security deposit?" />
                                                                                        <i class="form-control-feedback fa fa-dollar" style={{ left: "3px", paddingTop: "25px" }}></i>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-md-6">
                                                                                    <div class="form-group">
                                                                                        <label for="assignee">Collect the pet deposit now?</label>
                                                                                        <select class="form-control" value={collectPetDeposit} onChange={this.onHandlingPetDepositChange.bind(this)}>
                                                                                            <option key="0" value="Yes">Yes</option>
                                                                                            <option key="1" value="No">No</option>
                                                                                        </select>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="row">
                                                                                <div class="col-md-12">
                                                                                    <div class="form-group">
                                                                                        <label for="email_tenant">Request Electronic Signature?</label>
                                                                                        <br />
                                                                                        <input type="checkbox" disabled={disableESigToggle} class="toggle-switch-request-eSig" id="email_tenant" defaultChecked={requestElectronic} data-toggle="toggle" />
                                                                                        {disableESigToggle == true && (
                                                                                            <div>*To request a signature, you must <a href="#upload_agreement">upload</a> an agreement to this lease.</div>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            {collectSecurityDeposit == 'Yes' && rentPaymentOption == 'single' && (
                                                                                <div>*We will create an invoice for the primary tenant to pay the security deposit(s) for the amount of <b>${(securityDeposit)}</b></div>
                                                                            )}
                                                                            {collectSecurityDeposit == 'Yes' && rentPaymentOption == 'split' && (
                                                                                <div>*We will create an invoice and split the security deposit(s) between tenants for the total amount of <b>${(securityDeposit)}</b></div>
                                                                            )}
                                                                            {collectPetDeposit == 'Yes' && rentPaymentOption == 'single' && (
                                                                                <div>*We will create an invoice for the primary tenant to pay the pet deposit(s) for the amount of <b>${(petDeposit)}</b></div>
                                                                            )}
                                                                            {collectPetDeposit == 'Yes' && rentPaymentOption == 'split' && (
                                                                                <div>*We will create an invoice and split the pet deposit(s) between tenants for the total amount of <b>${(petDeposit)}</b></div>
                                                                            )}
                                                                            {collectSecurityDeposit == 'No' && (
                                                                                <div>*We will not create an invoice for the tenant(s) to pay the security deposit(s).</div>
                                                                            )}
                                                                            {collectPetDeposit == 'No' && (
                                                                                <div>*We will not create an invoice for the tenant(s) to pay the pet deposit(s).</div>
                                                                            )}
                                                                            {collectRentNow == 'Yes' && rentPaymentOption == 'single' && (
                                                                                <div>*We will create an invoice for the primary tenant to pay rent for the amount of <b>${rentAmount}</b></div>
                                                                            )}
                                                                            {collectRentNow == 'Yes' && rentPaymentOption == 'split' && (
                                                                                <div>*We will create an invoice and split the rent between tenants for the total amount of <b>${rentAmount}</b></div>
                                                                            )}
                                                                            {collectRentNow == 'No' && (
                                                                                <div>*We will not create an invoice for the tenant(s) to pay rent.</div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-8 col-md-offset-4 col-sm-8 col-sm-offset-4 col-xs-8 col-xs-offset-3">
                                                                            <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.moveIn.bind(this)}>
                                                                                Move In
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </form>
                                                            </Modal>
                                                        }
                                                    />
                                                )}
                                                <ActionCenterEntry
                                                    title="Signature Status"
                                                    description={leaseSigned}
                                                    buttonText={requestSigButtonText}
                                                    buttonCallback={this.onRequestESig.bind(this)}
                                                />
                                                <ActionCenterEntry
                                                    title="Security Deposit"
                                                    description={depositPaidText}
                                                    buttonText="Request Deposit"
                                                    buttonCallback={this.onRequestDeposit.bind(this)}
                                                    disabled={disableRequestDeposit}
                                                />
                                                <ActionCenterEntry
                                                    title="Lease Status"
                                                    description={leaseStatus}
                                                    buttonText="Renew Lease"
                                                    buttonCallback={this.onRequestRenewal.bind(this)}
                                                    disabled={disableRequestRenewal}
                                                    danger={alertLeaseStatus}
                                                />
                                            </ActionCenterCard>
                                            <div class="card" id="upload_agreement">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="header">
                                                            <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="icon-document-plus"></i></span> Lease Agreement</h4>
                                                            <p class="category">Upload relavant tenant documents</p>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <div class="content">
                                                                    {agreement == null ? (
                                                                        <div>
                                                                            <p style={{ textAlign: 'center' }}>No agreement found, attach one below.</p>
                                                                            <img class="aspect-fit" src="/assets/img/Artboard@4x-8.png" width="50%" />
                                                                        </div>
                                                                    ) : (
                                                                        agreement
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <div class="content">
                                                                    {this.state.dropZoneSetup !== undefined && (
                                                                        <div style={{ textAlign: "center" }}>
                                                                            <DropzoneComponent config={this.state.dropZoneConfig}
                                                                                eventHandlers={this.state.dropZoneEventHandlers}
                                                                                djsConfig={this.state.dropZoneJSConfig} />
                                                                            <button type="button" class="btn btn-info btn-secondary btn-fill dropZone-upload" autoComplete="off" onClick={this.triggerUpload.bind(this, 0, "current")}>Upload</button>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="header">
                                                            <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="pe-7s-cash"></i></span> Fees</h4>
                                                            <p class="category">Any fees added will automatically be included on each rent payment.</p>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <div class="content">
                                                                    {feeDetails != null && (
                                                                        <span>
                                                                            <p>Amount: <b>${feeDetails.fee_amount / 100}</b></p>
                                                                            <p>Percentage: <b>{feeDetails.fee_percentage}%</b></p>
                                                                        </span>
                                                                    )}
                                                                    <FeesSelect columnSize={0} sortID={fee} title="" onChange={this.handleFeeChange.bind(this)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Tab>
                                <Tab title="payments">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="card">
                                                <div class="header">
                                                    <h4 class="title">Payment History</h4>
                                                    <p class="category">History of all payments for this lease</p>
                                                </div>
                                                <div class="content">
                                                    <LeasePaymentHistory leaseID={this.state.leaseID} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Tab>
                                <Tab title="invoicing">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <LeaseInvoices leaseId={this.state.leaseID} ref="leaseInvoice" />
                                        </div>
                                    </div>
                                </Tab>
                                <Tab title="quickbooks">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="card">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="header">
                                                            <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="icon-person-outline"></i></span> Quickbooks Customer Name</h4>
                                                            <p class="category">Name of the Quickbooks customer that will be referenced</p>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-md-5 col-sm-12 col-xs-12">
                                                                <div class="content">
                                                                    <div class="form-group">
                                                                        <input type="text" class="form-control" value={qbCustomerRef} onChange={this.handleQbCustomerRefChange.bind(this)} placeholder="Property Group, LLC" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="card">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="header">
                                                            <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="icon-person-outline"></i></span> Quickbooks Item Name</h4>
                                                            <p class="category">Item reference to associate invoices to the specified customer name.</p>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-md-5 col-sm-12 col-xs-12">
                                                                <div class="content">
                                                                    <div class="form-group">
                                                                        <input type="text" class="form-control" value={qbItemRef} onChange={this.handleQbItemRefChange.bind(this)} placeholder="Rent Payment" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Tab>
                                 {chargePercentageClicked == 'clicked' && (
                                    <Tab title="sales reports">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="card">
                                                    <div class="header">
                                                        <h4 class="title">Reported Sales</h4>
                                                        <p class="category">Reported sales by tenants</p>
                                                    </div>
                                                    <SalesReportedList leaseId={this.state.leaseID} />
                                                </div>
                                            </div>
                                        </div>
                                    </Tab>
                                 )}
                             </TabGroup>
                        </div>
                    </div>
                </div>
                <div class="row blue-bottom">
                    <div class="blue-bottom-center-align">
                        <div class="col-md-6 col-sm-6 col-xs-12 blue-bottom-btn-right-push">
                            <button type="button" id="delete-tenant" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill" autoComplete="off" onClick={this.handleDeleteLease.bind(this)}>
                            Delete Lease
                            </button>
                        </div>
                        <div class="col-md-3 col-sm-6 col-xs-12">
                            <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-primary btn-info btn-fill" autoComplete="off" onClick={this.handleSaveLeaseData.bind(this)}>
                            Update Lease
                            </button>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
            )
        }
    }
};



// WEBPACK FOOTER //
// app/components/Lease/LeaseEditNew.jsx